// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.smallFont12 {
  font-size: 12px !important;
  line-height: 16px !important;
}

.smallFont14 {
  font-size: 14px;
  line-height: 22px;
}

.defaultFont {
  font-size: 15px !important;
  line-height: 22px !important;
}

.fontSize18Bold {
  font-size: 18px !important;
  font-weight: 700 !important;
}

.fontSize18Medium {
  font-size: 18px !important;
  font-weight: 500 !important;
}

.fontSize16Medium {
  font-size: 16px !important;
  font-weight: 600 !important;
}

.fontSize13Medium {
  font-size: 13px !important;
  font-weight: 600 !important;
}

.fontSize12Medium {
  font-size: 12px !important;
  font-weight: 600 !important;
}

.RegularFont {
  font-size: 16px !important;
}

.fontSize20 {
  font-size: 20px !important;
}

.ag-fontSize24 {
  font-size: 24px !important;
}

.ag-fontSize26 {
  font-size: 26px !important;
}

.ag-fontSize31 {
  font-size: 31px !important;
}

.ag-fontSize32 {
  font-size: 32px !important;
}

.fontSize40 {
  font-size: 40px !important;
}

.ag-fontSize30 {
  font-size: 30px !important;
  line-height: 38px;
  font-weight: 400;
}

.lineHeight20 {
  line-height: 20px !important;
}

.lineHeight40 {
  line-height: 40px !important;
}

.fontWeight600 {
  font-weight: 600;
}

.Sentence {
  text-transform: capitalize !important;
}

h1.ant-typography,
.ant-typography h1 {
  font-weight: 700;
  font-size: 36px;
}

h2.ant-typography,
.ant-typography h2 {
  font-weight: 700;
}

h3.ant-typography,
.ant-typography h3 {
  font-weight: 700;
}

h4.ant-typography,
.ant-typography h4 {
  font-weight: 400;
  margin-bottom: 20px;
  color: #646777;
}

h5.ant-typography,
.ant-typography h5 {
  font-weight: 400;
  margin-bottom: 20px;
  color: #646777;
}

.text-italic {
  font-style: italic;
}

.SentanceCase {
  text-transform: capitalize;
}

.text-white {
  color: #fff !important;
}

.text-grey {
  color: #B4BBC3 !important;
}

.text-base {
  color: #735AFF !important;
}

.text-step {
  color: #7D858F;
}

.font-300 {
  font-weight: 300 !important;
}

.font-400 {
  font-weight: 400 !important;
}

.font-500 {
  font-weight: 500 !important;
}

.fontSize24 {
  font-size: 24px !important;
}

.link-cursor {
  cursor: pointer;
}

.center-align-text {
  text-align: center;
}

.c-header {
  background: transparent;
  position: fixed;
  width: 100%;
  z-index: 1;
}
.c-header .ant-card-body {
  padding: 15px 30px 10px 30px;
}

.custom-select .ant-select-selection-placeholder {
  color: #fff;
}
.custom-select .ant-select-selection-item {
  color: #fff;
}
.custom-select.ant-select-open .ant-select-selection-item {
  color: #fff;
}

.ant-select-arrow {
  color: #fff;
}

.search-input {
  background: #f2f4f7;
  padding: 0px !important;
  border: none;
}
.search-input .ant-select-selection-placeholder {
  color: #7D858F;
}
.search-input .ant-input {
  background: #f2f4f7;
}
.search-input .ant-input-prefix {
  margin-right: 10px;
}

.site-page-header {
  padding: 0;
}
.site-page-header .ant-page-header-heading-left {
  margin: 0;
}

::-webkit-scrollbar {
  width: 5px;
  display: none;
}

::-webkit-scrollbar-thumb {
  border-radius: 10px;
  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
  background: rgba(0, 0, 0, 0.2);
}

::-webkit-scrollbar-track {
  box-shadow: inset 0 0 5px #f2f4f7;
  border-radius: 0;
  background: rgba(0, 0, 0, 0);
}

@media (min-width: 1100px) {
  .base-layout {
    padding: 81px 20px 0px 20px;
  }
}
@media (min-width: 1650px) {
  .base-layout {
    padding: 70px 30px 0px 30px;
  }
}
@media only screen and (min-width: 360px) and (max-width: 1100px) {
  .base-layout {
    padding: 130px 10px 10px 10px;
  }
}

.ant-layout-sider {
  background: transparent;
}

.flexibleRow {
  display: grid;
  grid-gap: 20px;
  grid-template-columns: repeat(auto-fill, minmax(378px, 1fr));
}

.twocol-3070 {
  display: flex;
}
@media (max-width: 1500px) {
  .twocol-3070 {
    flex-wrap: wrap;
  }
}

.side-detail {
  width: 380px;
  max-width: 380px;
  min-width: 300px;
  padding-right: 20px;
}
@media (min-width: 1920px) {
  .side-detail {
    min-width: 380px;
  }
}
@media (max-width: 1500px) {
  .side-detail {
    width: 100%;
    min-width: unset;
    max-width: 100%;
    padding-right: 0;
    padding-bottom: 20px;
  }
}

.side-form {
  width: 780px;
  max-width: 100%;
}
@media (min-width: 1921px) {
  .side-form {
    width: 100%;
  }
}
@media (max-width: 1500px) {
  .side-form {
    width: 100%;
  }
}

.css-11r8ynb-MultiValueGeneric {
  color: #000 !important;
}

.css-18hvbcy-multiValue {
  padding: 0 3px 0 14px !important;
}

.css-1tj4mlw-indicatorSeparator {
  background-color: #fff !important;
}

.main-menu {
  background: transparent !important;
  border: none;
}
.main-menu .menu-item .ant-menu-title-content {
  margin-left: 15px;
}
.main-menu .ant-menu-item-selected {
  background: #EEECFF !important;
}
.main-menu .ant-menu-item-selected .ant-menu-title-content {
  font-weight: 600;
  color: #252422;
}
.main-menu .ant-menu-item-selected .anticon path {
  fill: #735AFF;
  stroke: #735AFF;
  opacity: 100%;
}
.main-menu .ant-menu-item-selected:after {
  transform: scaleY(0);
  opacity: 1;
}

.menu-item {
  color: transparent;
  margin: 0 0 10px !important;
  border-radius: 10px;
  padding: 10px 15px !important;
  height: auto !important;
}
.menu-item .ant-menu-title-content {
  font-weight: 600;
  color: #7D858F;
}
.menu-item:hover {
  background: #EEECFF;
}
.stats-icon {
  stroke: #0e0e0e;
}

.ant-menu-title-content {
  font-weight: 300;
}

.ant-menu .ant-menu-item-disabled,
.ant-menu .ant-menu-submenu-disabled,
.ant-menu .ant-menu-item-disabled > a,
.ant-menu .ant-menu-submenu-disabled > a,
.ant-menu .ant-menu-item-disabled > span > a,
.ant-menu .ant-menu-submenu-disabled > span > a {
  color: #7D858F !important;
  opacity: 1;
  cursor: default;
}

.submenu-item {
  background-color: transparent;
}
.submenu-item .ant-menu-submenu-title {
  color: #646777;
}
.submenu-item .ant-menu-sub {
  color: #646777;
}
.submenu-item .menu-item:last-child {
  margin-bottom: 0 !important;
}

.side-card {
  padding-top: 125px;
  height: calc(100vh - 40px);
  overflow: hidden;
  transition: 0.2s;
  background: transparent;
  border-radius: 0px;
}
.side-card .ant-card-body {
  padding: 0px;
  background: transparent;
}

.navBar > .ant-card-body {
  padding: 0;
  background: transparent;
}

.navBarResponse .menu-item {
  border-radius: 6px;
  padding: 10px 15px !important;
  height: 40px !important;
  width: 50px !important;
  margin-left: 25px !important;
}
.navBarResponse .menu-item .anticon {
  font-size: 20px !important;
  line-height: 1 !important;
}
.navBarResponse .ant-divider-horizontal {
  margin: 20px 0;
  min-width: unset;
  width: 50px;
}

.drawer-style .ant-drawer-header {
  padding: 16px 24px;
  z-index: 99999;
  top: 0;
  left: 0;
  right: 0;
  border-bottom: 1px solid #e8e8e8;
}
.drawer-style .ant-drawer-body {
  padding: 0px;
}

.password-strength .ant-checkbox-disabled .ant-checkbox-inner {
  border-color: #735AFF !important;
  background-color: transparent !important;
}
.password-strength .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after {
  border-color: #735AFF !important;
}

input:-webkit-autofill,
input:-webkit-autofill:hover,
input:-webkit-autofill:focus,
textarea:-webkit-autofill,
textarea:-webkit-autofill:hover,
textarea:-webkit-autofill:focus,
select:-webkit-autofill,
select:-webkit-autofill:hover,
select:-webkit-autofill:focus {
  border: 0;
  box-shadow: 0 0 0px 100px #f2f4f7 inset;
  -webkit-box-shadow: 0 0 0px 100px #f2f4f7 inset;
  -webkit-text-fill-color: #7D858F !important;
}

.d-none {
  display: none !important;
}

.d-block {
  display: block !important;
}

.d-inline-block {
  display: inline-block !important;
}

.w-100 {
  width: 100% !important;
}

.max-100 {
  max-width: 100px;
}

.h-100 {
  height: 100%;
}

.h-auto {
  height: auto !important;
}

.ultra-550 {
  height: 400px !important;
}

.text-center {
  text-align: center !important;
}

.text-right {
  text-align: right !important;
}

.text-left {
  text-align: left !important;
}

.justify-right {
  justify-content: flex-end;
}

.justify-cetner {
  justify-content: center;
}

.position-relative {
  position: relative;
}

.border-left {
  border-left: 1px solid #2c2c2c;
}

.right-fixed {
  position: absolute;
  top: 0;
  right: 10px;
}

.p-0 {
  padding: 0 !important;
}

.px-1 {
  padding-left: 15px !important;
  padding-right: 15px !important;
}

.px-2 {
  padding-left: 80px !important;
  padding-right: 80px !important;
}

.py-0 {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
}

.m-0 {
  margin: 0 !important;
}

.mb-0 {
  margin-bottom: 0 !important;
}

.py-1 {
  padding-top: 10px;
  padding-bottom: 10px;
}

.py-5 {
  padding-top: 50px;
  padding-bottom: 50px;
}

.mb-10PX {
  margin-bottom: 10px !important;
}

.ml-5 {
  margin-left: 5px !important;
}

.mt-0 {
  margin-top: 0 !important;
}

.mt-70 {
  margin-top: 70px !important;
}

.mb-1 {
  margin-bottom: 15px !important;
}

.mb-1-5 {
  margin-bottom: 20px !important;
}

.mb-2 {
  margin-bottom: 30px !important;
}

.mt-1 {
  margin-top: 15px !important;
}

.mt-1-5 {
  margin-top: 20px !important;
}

.mt-2 {
  margin-top: 30px !important;
}

.mt-4 {
  margin-top: 40px !important;
}

.mt-5 {
  margin-top: 50px !important;
}

.ml-auto {
  margin-left: auto;
}

.pl-0 {
  padding-left: 10px !important;
}

.pl-1 {
  padding-left: 20px !important;
}

.pl-2 {
  padding-left: 30px !important;
}

.c-default {
  color: #bebebe !important;
}

.c-gray {
  color: #7D858F !important;
}

.c-black {
  color: #252422 !important;
}

.c-white {
  color: #fff !important;
}

.c-link {
  color: #0077b6;
}

.linkbtn {
  height: auto;
  line-height: 20px;
}

.c-gray-linkbtn {
  color: #7D858F;
  height: auto;
  line-height: 20px;
}
.c-gray-linkbtn:hover, .c-gray-linkbtn:focus {
  color: #fff;
}

.downloadLink {
  display: flex;
  align-items: center;
  color: #02a574;
  line-height: 20px;
}
.downloadLink:hover, .downloadLink:focus {
  color: #fff;
}

.cross-iconbtn {
  width: 20px !important;
  height: 20px !important;
  padding: 0 !important;
  border-radius: 0;
  font-size: 20px !important;
  line-height: 1;
  vertical-align: middle;
  border: 0;
  color: #bebebe !important;
}
.cross-iconbtn > * {
  font-size: 20px;
}
.cross-iconbtn:hover, .cross-iconbtn:focus {
  color: #c3423f !important;
}

.graycross-icon {
  color: #7D858F !important;
}
.graycross-icon:hover, .graycross-icon:focus {
  color: #c3423f !important;
}

.dashed-borderedbtn {
  border-style: dashed;
}

.c-graybtn {
  background-color: #2c2c2c;
  border: 0;
}

.c-success {
  color: #02a574 !important;
}

.b-success {
  color: #fff;
  background-color: #02a574;
}

.c-pending {
  color: #e89005 !important;
}

.b-pending {
  background-color: #e89005;
  color: #fff;
}

.b-black {
  background-color: #0e0e0e !important;
}

.b-dark-gray {
  background-color: #f2f4f7;
}

.b-gray {
  background: #f2f4f7;
}

.c-error {
  color: #c3423f !important;
}

.b-error {
  color: #fff !important;
  background-color: #c3423f !important;
}
.b-error .op-6 {
  color: #fff;
}

.b-default {
  color: #fff;
  background-color: #2c2c2c;
}

.b-primary {
  color: #fff;
  background-color: #0077b6;
}

.c-primary {
  color: #0077b6;
}

.sole-icon {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  padding: 10px;
  display: inline-block;
}
.sole-icon .anticon {
  vertical-align: 0;
  color: #0e0e0e;
  line-height: 20px;
}

.mt-PX {
  margin-top: 10px !important;
}

.sole-anticon {
  font-size: 40px !important;
}

.sole-icon-small {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  padding: 5px;
  display: inline-block;
  font-size: 10px;
}
.sole-icon-small .anticon {
  font-size: 1em !important;
  color: #0e0e0e;
  line-height: 10px;
}

.white-link {
  color: #fff;
  font-weight: 300;
  padding: 0;
  line-height: 2;
}
.white-link span {
  text-decoration: underline;
}
.white-link:hover {
  color: #bebebe;
}

.inAvatar {
  position: absolute;
  bottom: 0;
  right: 0;
  border: 10px solid #0e0e0e;
}

.thick-border-bottom {
  border-bottom: 3px solid #2c2c2c !important;
}

.highlight-border {
  border-color: #bebebe !important;
}

.small-btn {
  height: auto;
  border-radius: 15px;
}

.save-btn {
  margin-top: 2em;
}

.op-1 {
  opacity: 0.1;
}

.op-2 {
  opacity: 0.2;
}

.op-3 {
  opacity: 0.3;
}

.op-4 {
  opacity: 0.4;
}

.op-5 {
  opacity: 0.5;
}

.op-6 {
  opacity: 0.6;
}

.op-7 {
  opacity: 0.7;
}

.op-8 {
  opacity: 0.8;
}

.op-9 {
  opacity: 0.9;
}

.list-links {
  padding: 0;
  margin: 0;
  white-space: pre-wrap;
  line-height: 1.3;
  text-align: left;
  height: auto;
  color: #bebebe;
}
.list-links:hover {
  color: #fff;
}

.btnoutline-white {
  background: transparent;
  border-color: #fff;
  color: #fff;
}
.btnoutline-white:hover, .btnoutline-white:focus {
  background: #fff;
  border-color: #fff;
  color: #0e0e0e;
}
.btnoutline-white:active {
  background: #fff;
  border-color: #fff;
}

.green-btn {
  background: #02a574;
  border-color: #02a574;
}
.green-btn:hover, .green-btn:focus {
  background: #03865e;
  border-color: #03865e;
}
.green-btn:active {
  background: #016b4b;
  border-color: #016b4b;
}

.black-btn {
  background: #000;
  border-color: #000;
}
.black-btn:hover, .black-btn:focus {
  background: #222;
  border-color: #222;
}
.black-btn:active {
  background: #121212;
  border-color: #121212;
}

.red-btn {
  background: #c3423f;
  border-color: #c3423f;
}
.red-btn:hover, .red-btn:focus {
  background: #ab3836;
  border-color: #ab3836;
}
.red-btn:active {
  background: #ab3836;
  border-color: #ab3836;
}

.gray-btn {
  background: #bebebe;
  border-color: #bebebe;
}
.gray-btn:hover, .gray-btn:focus {
  color: #fff;
  background: #bebebe;
  border-color: #bebebe;
}
.gray-btn:active {
  color: #fff;
  background: #bebebe;
  border-color: #bebebe;
}

.activeIcon {
  font-size: 30px;
}

.customSelect {
  line-height: 20px;
}
.customSelect:hover > div .css-1hb7zxy-IndicatorsContainer > div {
  color: #6F5BF6;
}
.customSelect:hover > div .css-1pahdxg-control {
  display: none;
}
.customSelect > div {
  border-radius: 8px;
  box-shadow: none;
}
.customSelect > div .css-1uccc91-singleValue {
  margin: 0;
}
.customSelect > div .css-1hb7zxy-IndicatorsContainer > div {
  margin: 5px 15px 5px 5px;
  background-color: #EEECFF;
  border-radius: 4px;
}
.customSelect > div div span {
  display: none;
}

.icon-list {
  height: 340px;
  overflow-x: hidden;
}
.icon-list .ant-list-item {
  padding: 15px 0;
}
.icon-list .ant-list-item .titlename {
  transition: 0.3s;
}
.icon-list .ant-list-item:hover .titlename {
  color: #fff !important;
}

.withoutFigure {
  height: 461px;
}

.ant-form-item-has-error .customSelect {
  border: 1px solid #c3423f;
  border-radius: 8px;
}

.download-inputbtn {
  position: absolute;
  right: 30px;
  padding: 0;
  top: 6px;
  z-index: 1;
}

.inline-form {
  flex-wrap: nowrap;
}
.inline-form .ant-form-item {
  flex: auto;
}

.member-icon {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-evenly;
  width: 100%;
}
.member-icon .ant-avatar {
  border: 0;
  margin: 10px 0;
}
.member-icon .ant-avatar:not(:first-child) {
  margin: 10px 0;
}

.ant-layout-footer {
  padding-left: 0;
  padding-right: 0;
}

.ant-input-affix-wrapper:focus,
.ant-input-affix-wrapper-focused {
  box-shadow: none;
}

.ant-input-prefix {
  margin-right: 10px;
}

.ant-form-item-explain,
.ant-form-item-extra {
  font-size: 13px;
}

.ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {
  content: none;
}

.ant-form-item-label > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::after {
  display: inline-block;
  margin-left: 4px;
  color: #c3423f;
  font-size: 12px;
  font-family: SimSun, sans-serif;
  line-height: 1;
  content: "*";
}

.ant-input-search .ant-input:focus {
  border-color: #0077b6;
}

.ant-switch-handle {
  width: 18px;
  height: 18px;
}

.ant-switch-checked .ant-switch-handle {
  left: calc(100% - 18px - 3px);
}

.ant-input {
  padding: 11.5px 15px;
}

.ant-input-number {
  padding: 3.5px 15px;
}

.width100percent .ant-input-number {
  width: 100%;
}

.padding-left-right {
  padding-left: 15px;
  padding-right: 15px;
}

.ant-input-affix-wrapper-lg {
  padding: 11.5px 15px;
}

.inputGroupWithClose .ant-input-group-addon {
  padding: 0;
  border: 0;
  min-width: 90px;
}
.inputGroupWithClose .ant-input {
  width: calc(100% - 20px);
  margin-left: 20px;
  border-radius: 8px !important;
}

.doubleVal {
  display: flex;
  justify-content: space-between;
}

.uploadWithbtn .ant-upload {
  width: 100%;
}

.avatar-uploader > .ant-upload {
  width: 100%;
  height: 225px;
}

.uploadTemplate > .ant-upload {
  width: 100%;
  height: 110px;
}

.ant-btn-dashed {
  color: #0077b6;
  border-color: #0077b6;
}

.ant-anchor-wrapper {
  margin-left: 0;
  padding-left: 0;
}

.ant-anchor {
  line-height: 20px;
  padding-left: 0;
}

.ant-anchor-link {
  padding: 0;
  line-height: 1;
}

.ant-select:not(.ant-select-customize-input) .ant-select-selector {
  background-color: #fff !important;
  border: 1px solid rgba(64, 61, 57, 0.1450980392);
  box-shadow: none !important;
  padding: 1px 14px;
}

.ant-select-single.ant-select-lg:not(.ant-select-customize-input) .ant-select-selector {
  padding: 0 15px;
}

.ant-select-arrow {
  right: 15px;
}

.clickRow .ant-table-row {
  cursor: pointer;
}

.cursor-pointer {
  cursor: pointer;
}

.ant-progress-show-info .ant-progress-outer {
  margin-right: calc(-3em - 8px);
  padding-right: calc(3em + 8px);
}

.ant-pagination-item {
  border: 0px;
}

.ant-pagination-item-active {
  background-color: #fff;
  border: 1px solid #6F5BF6;
}

.ant-radio-wrapper {
  border: 1px solid rgba(64, 61, 57, 0.1450980392);
  padding: 10px 63px 12px 12px;
  border-radius: 6px;
}

.ant-message {
  color: #fff;
  top: 0;
}
.ant-message .ant-message-notice {
  padding: 0;
}
.ant-message .ant-message-notice .ant-message-notice-content {
  background-color: transparent;
  padding: 0;
  box-shadow: none;
  display: block;
}
.ant-message .ant-message-notice .ant-message-notice-content .ant-message-custom-content {
  display: block;
  padding: 10px;
}
.ant-message .ant-message-notice .ant-message-notice-content .ant-message-custom-content.ant-message-error {
  background: rgba(238, 17, 17, 0.8);
}
.ant-message .ant-message-notice .ant-message-notice-content .ant-message-custom-content.ant-message-error .anticon {
  color: #fff;
}
.ant-message .ant-message-notice .ant-message-notice-content .ant-message-custom-content.ant-message-success {
  background: rgba(2, 165, 116, 0.8);
}
.ant-message .ant-message-notice .ant-message-notice-content .ant-message-custom-content.ant-message-success .anticon {
  color: #fff;
}

.ant-message:has(.export-limit-warning) {
  z-index: 0 !important;
  pointer-events: none;
}
.ant-message:has(.export-limit-warning) .ant-message-notice {
  pointer-events: auto;
}

.disableBody .ant-form-item-label label:after {
  display: none !important;
}
.disableBody .fullWidth-checbox {
  display: none !important;
}

.ant-drawer-header-title {
  display: none;
}

.ant-breadcrumb-link {
  background-color: #f5f5f5;
  border-radius: 9.5px;
  padding: 2px 9px;
  font-size: 12px;
}

.ant-divider-dashed {
  border-width: 3px 0 0;
}

.group-avatar .ant-avatar-circle {
  margin-right: 10px;
}

.billing-slider body .ant-tooltip-inner {
  padding: 5px 7px 0px 7px;
  background: #55cde5;
  color: white;
  border-radius: 100px;
}

.btn-link .ant-btn-link {
  color: #6F5BF6 !important;
}

.auto-select-remove {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: "none";
  user-select: none;
}

.ant-input-search-large .ant-input-search-button {
  height: 49px;
}

.item-width-100 .ant-descriptions-item-label {
  width: 100%;
}

.status-dot .ant-badge-status-dot {
  height: 10px;
  width: 10px;
}

.dashboard-subtitle {
  font-weight: 400;
  font-size: 24px;
}

.video-frame {
  border-radius: 8px;
}

.ant-steps-label-vertical .ant-steps-item-content {
  display: block;
  width: 110px;
  margin-top: -160px;
  text-align: center;
  /* Additional styles can be added here */
}

.step-style {
  margin-top: 18vh;
  padding-bottom: 10vh;
}

.step-avatar-text {
  color: #7D858F;
  font-size: 14px;
  font-weight: 600;
}

.ant-divider-vertical {
  position: relative;
  top: -0.06em;
  display: inline-block;
  height: 0.9em;
  margin: 0 8px;
  vertical-align: middle;
  border-top: 0;
  border-left: 2px solid #D9DCE0;
}

.empty-notification {
  padding-left: 20px;
  padding-right: 20px;
}

.align-center .ant-card-body {
  display: flex;
  align-items: center;
  justify-content: center;
}

.dummy-image-container {
  justify-content: center;
  align-items: center;
  display: flex;
  margin-top: 30px;
  margin-bottom: 30px;
}

.dummy-image-container-guest {
  justify-content: center;
  align-items: center;
  display: flex;
  margin-bottom: 30px;
}

.dummy-image-border {
  border-radius: 7px;
  box-shadow: 0px 10px 25px 0px rgba(0, 0, 0, 0.0705882353);
  border: 1px solid #C7BEFF;
}

.payment-text-color {
  color: #5c5c5c !important;
}

.heading-desc {
  margin-top: 15px;
  margin-bottom: 20px;
}

.export-limit-warning {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border-radius: 8px;
  background: rgba(250, 137, 0, 0.15);
  color: #8a4c00;
  font-weight: 600;
  font-size: 14px;
  border: 1px solid rgba(250, 137, 0, 0.35);
  box-shadow: 0 8px 18px rgba(250, 137, 0, 0.15);
  margin: 0 auto;
  max-width: 110vw;
  text-align: center;
}

.login-card {
  background: transparent;
}
.login-card .ant-card-body {
  padding: 50px 30px;
}
@media (max-width: 1366px) {
  .login-card .ant-card-body {
    padding: 32px 20px;
  }
}
@media (max-width: 767px) {
  .login-card .ant-card-body {
    padding: 24px 12px;
  }
}

.ant-card-body:before, .ant-card-body:after {
  content: none;
}

.design-card {
  height: 100%;
  border-radius: 20px;
  transition: 0.2s;
  box-shadow: 0px 5px 20px rgba(225, 125, 56, 0.1), inset 0px 4px 4px #ffffff;
}
.design-card .ant-card-body {
  position: relative;
  padding: 30px;
}
@media (max-width: 1366px) {
  .design-card .ant-card-body {
    padding: 20px;
  }
}
@media (max-width: 767px) {
  .design-card .ant-card-body {
    padding: 12px;
  }
}

.design-card-payment {
  height: 100%;
  border-radius: 20px;
  transition: 0.2s;
  width: 100%;
}
.design-card-payment .ant-card-body {
  position: relative;
  padding: 30px;
}
@media (max-width: 1366px) {
  .design-card-payment .ant-card-body {
    padding: 20px;
  }
}
@media (max-width: 767px) {
  .design-card-payment .ant-card-body {
    padding: 12px;
  }
}

.design-card-guest-dashboard {
  height: 100%;
  border-radius: 20px;
  transition: 0.2s;
  box-shadow: 0px 5px 20px rgba(225, 125, 56, 0.1), inset 0px 4px 4px #ffffff;
}
.design-card-guest-dashboard .ant-card-body {
  position: relative;
  padding-left: 15vh;
  padding-top: 10vh;
  padding-right: 10vh;
}
@media (max-width: 1366px) {
  .design-card-guest-dashboard .ant-card-body {
    padding: 20px;
  }
}
@media (max-width: 767px) {
  .design-card-guest-dashboard .ant-card-body {
    padding: 12px;
  }
}

.side-panel {
  height: calc(100vh - 296px);
}
.side-panel .ant-card-body {
  height: 100%;
}

.transparent-card {
  width: 100%;
  overflow-x: hidden;
  background: transparent;
}
.transparent-card > .ant-card-body {
  padding: 0px 0px 0px 30px;
}

.small-card {
  width: 100%;
  overflow-x: hidden;
  background: transparent;
}
.small-card > .ant-card-body {
  padding: 0px 0px 0px 0px;
}

.os-card {
  width: 341px;
  height: 315px;
  padding: 40px;
  display: "flex";
  flex-direction: "column";
  justify-content: "center";
}

.no-card-aform {
  width: 100%;
  background-color: transparent;
  margin-bottom: 10px;
}
.no-card-aform > .ant-card-body {
  padding: 0;
}

.statistic-card {
  width: 100%;
  height: 100%;
  border-radius: 0;
  border-left: 1px solid #2c2c2c;
  background-color: transparent;
  overflow-x: hidden;
}
.statistic-card > .ant-card-body {
  padding: 0 30px;
}

.stats-card {
  background: #ffffff;
  border: 1px solid #C7BEFF;
  border-radius: 12px;
}

.design-card-small {
  height: 100%;
  border-radius: 8px;
}
.design-card-small > .ant-card-body {
  padding: 20px;
}
.design-card-small .anticon {
  font-size: 20px;
}

.design-card-xsmall {
  height: 100%;
  border-radius: 8px;
}
.design-card-xsmall > .ant-card-body {
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 20px;
  padding-bottom: 0px;
}
.design-card-xsmall .anticon {
  font-size: 20px;
}

.figures-card {
  transition: 0.2s;
}
.figures-card .ant-card-body {
  padding: 20px;
}

.landscape-card {
  height: 100%;
}
.landscape-card .ant-card-body {
  height: "100% !important";
  display: flex;
  flex-flow: column;
  justify-content: space-between;
}

.nospace-card {
  background: transparent !important;
  width: 100%;
  box-shadow: none !important;
}
.nospace-card .ant-card-body {
  padding: 0;
}

.logs-table {
  background: transparent !important;
  width: 100%;
  height: 94% !important;
  box-shadow: none !important;
}
.logs-table .ant-card-body {
  padding: 0;
}

.custom-card-graph .ant-card-body {
  border: none !important;
}

.custom-card-graph .ant-card-head {
  border: none !important;
}

.ant-card .ant-card-bordered .custom-card-graph {
  border: none !important;
}

.copyable-card .ant-card-body {
  max-width: 95%;
}

.black-modal .ant-modal-content {
  border-radius: 12px;
}
.black-modal .ant-modal-confirm-body {
  display: flex;
  flex-direction: column;
  text-align: center;
}
.black-modal .ant-modal-confirm-body .anticon {
  float: none;
  margin: 0 0 20px;
  font-size: 50px;
}
.black-modal .ant-modal-confirm-body .ant-modal-confirm-title {
  font-size: 26px;
  font-weight: 400;
  margin: 0 0 20px;
}
.black-modal .ant-modal-confirm-body .ant-modal-confirm-content {
  margin: 0;
  line-height: 20px;
}
.black-modal .ant-modal-confirm-btns {
  float: none;
  margin-top: 50px;
}

.reqData .ant-descriptions-item {
  border-bottom: 0.7px solid rgb(224, 214, 227);
}
.reqData .ant-descriptions-item-label {
  background: transparent;
}
.custom-tabs {
  overflow: unset;
}
@media only screen and (min-width: 360px) and (max-width: 767px) {
  .custom-tabs > .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-nav-list {
    width: none;
  }
}
@media (min-width: 768px) {
  .custom-tabs > .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-nav-list {
    width: 35%;
  }
}
.custom-tabs > .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-nav-list {
  padding: 5px;
  border-radius: 8px;
}
.custom-tabs > .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-nav-list .ant-tabs-tab {
  width: 100%;
  height: 40px;
  border-radius: 8px !important;
  justify-content: center;
}
.custom-tabs > .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-nav-list .ant-tabs-ink-bar {
  height: 4px;
  border-radius: 20px;
}
.custom-tabs > .ant-tabs-nav .ant-tabs-tab,
.custom-tabs > div > .ant-tabs-nav .ant-tabs-tab {
  border: 0;
}
.-space30 .ant-tabs-nav {
  margin-bottom: 30px;
}

.tab-badge .ant-badge-count {
  padding: 0 15px;
  height: 30px;
  font-size: 15px;
  line-height: 30px;
  background-color: #2c2c2c;
  color: #fff;
}

.menu-badge .ant-badge-count {
  width: 20px;
  height: 20px;
  font-size: 15px;
  line-height: 20px;
  border-radius: 4px;
  background-color: #0e0e0e;
  color: #fff;
  padding: 0;
}

.tab-bold {
  position: relative;
}
.tab-bold > .ant-tabs-nav .ant-tabs-tab {
  border: 0;
  font-size: 18px;
  font-weight: 400;
}
.tab-bold > .ant-tabs-nav .ant-tabs-tab .ant-tabs-tab-btn {
  color: #7D858F;
}
.tab-bold > .ant-tabs-nav .ant-tabs-tab .tab-header {
  color: #7D858F;
  transition: 0.2s;
  font-size: 18px;
  font-weight: 400;
}
.tab-bold > .ant-tabs-nav .ant-tabs-tab:first-child {
  padding-left: 0;
}
.tab-bold > .ant-tabs-nav:before {
  content: none;
}
.tab-bold > .ant-tabs-nav .ant-tabs-tab-active {
  background-color: transparent;
  font-size: 26px;
  font-weight: 400;
}
.tab-bold > .ant-tabs-nav .ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #fff;
}
.tab-bold > .ant-tabs-nav .ant-tabs-tab-active .tab-header {
  color: #fff;
  font-size: 24px;
  font-weight: 400;
}
.tab-bold > .ant-tabs-nav .ant-tabs-tab-active .tab-badge .ant-badge-count {
  background-color: #c3423f;
}
.tab-bold > div > .ant-tabs-nav .ant-tabs-tab {
  border: 0;
  font-size: 18px;
  font-weight: 400;
}
.tab-bold > div > .ant-tabs-nav .ant-tabs-tab .ant-tabs-tab-btn {
  color: #7D858F;
}
.tab-bold > div > .ant-tabs-nav .ant-tabs-tab .tab-header {
  color: #7D858F;
  font-size: 18px;
  font-weight: 400;
}
.tab-bold > div > .ant-tabs-nav:before {
  content: none;
}
.tab-bold > div > .ant-tabs-nav .ant-tabs-tab-active {
  font-size: 26px;
  font-weight: 400;
  background-color: transparent;
}
.tab-bold > div > .ant-tabs-nav .ant-tabs-tab-active .ant-tabs-tab-btn {
  color: #fff;
}
.tab-bold > div > .ant-tabs-nav .ant-tabs-tab-active .tab-header {
  color: #fff;
  font-size: 26px;
  font-weight: 400;
}

.optionsTabs {
  top: 13px;
  right: 0;
}
.optionsTabs .ant-radio-button-wrapper {
  border: 0;
  font-size: 16px;
  line-height: 2;
  background: #f2f4f7;
}
.optionsTabs .ant-radio-button-wrapper:first-child {
  border: 0;
}
.optionsTabs .ant-radio-button-wrapper:not(:first-child)::before {
  content: none;
}

.optionsTabsRes {
  position: relative;
  top: 0;
  justify-content: flex-end;
  width: 100%;
}

.payment_tabs {
  overflow: unset;
}
.payment_tabs > .ant-tabs-nav::before {
  content: normal;
}
.payment_tabs > .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-nav-list {
  width: 55%;
  padding: 5px 5px 10px 5px;
}
.payment_tabs > .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-nav-list .ant-tabs-tab {
  width: 100%;
  border: 1px solid rgba(141, 149, 160, 0.25);
  height: 60px;
  border-radius: 8px !important;
  margin-right: 15px;
  font-weight: 700;
  font-size: 13px;
  background-color: white;
}
.payment_tabs > .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-nav-list .ant-tabs-tab:hover {
  color: black;
}
.payment_tabs > .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-nav-list .ant-tabs-tab.ant-tabs-tab-active {
  color: black;
  background-color: white;
  box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.15);
}
.payment_tabs > .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-nav-list .ant-tabs-tab.ant-tabs-tab-active .ant-tabs-tab-btn {
  color: black;
}
.payment_tabs > .ant-tabs-nav .ant-tabs-tab,
.payment_tabs > div > .ant-tabs-nav .ant-tabs-tab {
  border: 0;
}
.payment_tabs > .ant-tabs-nav .ant-tabs-tab-active,
.payment_tabs > div > .ant-tabs-nav .ant-tabs-tab-active {
  color: #fff;
  background-color: #0077b6;
}

.billing-tabs {
  overflow: unset;
}
.billing-tabs > .ant-tabs-nav::before {
  content: normal;
}
.billing-tabs > .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-nav-list {
  width: 55%;
  padding: 5px 5px 10px 5px;
}
.billing-tabs > .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-nav-list .ant-tabs-tab {
  width: 100%;
  border: 1px solid rgba(141, 149, 160, 0.25);
  height: 60px;
  border-radius: 8px !important;
  margin-right: 15px;
  background-color: white;
  justify-content: center;
}
.billing-tabs > .ant-tabs-nav .ant-tabs-nav-wrap .ant-tabs-nav-list .ant-tabs-tab.ant-tabs-tab-active {
  box-shadow: 0px 4px 12px rgba(0, 180, 216, 0.2);
  border-color: #6F5BF6;
}
.billing-tabs > .ant-tabs-nav .ant-tabs-tab,
.billing-tabs > div > .ant-tabs-nav .ant-tabs-tab {
  border: 0;
}

.payment-slider .ant-slider-rail {
  background-color: transparent;
  border: 1px solid #55CDE5;
  border-style: dashed;
}

.custom-table .ant-table-thead > tr > th,
.custom-table .ant-table-tbody > tr > td {
  font-weight: 400;
  line-height: 1;
  padding: 18px 0px 18px 30px;
}
.custom-table .ant-table-thead > tr > th {
  color: #252422;
  background-color: #EEECFF;
}
.ant-table-thead th.ant-table-column-has-sorters:hover {
  background-color: #EEECFF;
}

.radio-tabs {
  display: flex;
  width: 100%;
  padding: 5px;
  background-color: #0e0e0e;
  border-radius: 12px;
}
.radio-tabs .ant-radio-button-wrapper {
  color: #7D858F;
  width: 100%;
  border-radius: 8px;
  border: 0;
  text-align: center;
}
.radio-tabs .ant-radio-button-wrapper:not(:first-child)::before {
  content: none;
}
.radio-tabs .ant-radio-button-wrapper:hover {
  color: #fff;
}

.transparent-table .ant-table {
  background-color: transparent !important;
}
.transparent-table .ant-table thead > tr > th {
  background-color: transparent !important;
  border-bottom: 1px solid #2c2c2c !important;
}

.fullWidth-checbox label {
  width: 50%;
  padding: 8.5px 15px;
  background: transparent;
  border-radius: 8px;
  display: flex;
  align-items: center;
  flex-flow: row-reverse;
  justify-content: space-between;
}
.fullWidth-checbox label span {
  color: #646777;
  line-height: 20px;
  padding-left: 0;
}
.fullWidth-checbox .ant-checkbox {
  top: 0;
}
.fullWidth-checbox .ant-checkbox-inner {
  border-radius: 4px;
}
.fullWidth-checbox .ant-checkbox-group-item::after {
  content: none;
}

.graycheckbox .ant-checkbox-wrapper:hover .ant-checkbox-inner,
.graycheckbox .ant-checkbox:hover .ant-checkbox-inner,
.graycheckbox .ant-checkbox .ant-checkbox-input:focus + .ant-checkbox-inner {
  border-color: #bebebe;
}
.graycheckbox .ant-checkbox-checked .ant-checkbox-inner,
.graycheckbox .ant-checkbox-checked:hover .ant-checkbox-inner,
.graycheckbox .ant-checkbox-wrapper:hover .ant-checkbox-checked .ant-checkbox-inner,
.graycheckbox .ant-checkbox-checked .ant-checkbox-input:focus + .ant-checkbox-inner {
  border-color: #f2f4f7;
  background: #f2f4f7;
}
.graycheckbox .ant-checkbox-checked::after {
  border-color: #f2f4f7;
}
.graycheckbox .ant-checkbox-checked .ant-checkbox-inner::after {
  border-color: #7D858F;
}

.labeldefaultFont {
  align-items: center;
}
.labeldefaultFont .ant-form-item-label > label {
  font-size: 15px;
  line-height: 24px;
}

.gray-input .ant-input {
  background-color: #2c2c2c;
}

.select-withicon .searchIcon {
  position: absolute;
  top: 8px;
  left: 20px;
  font-size: 20px;
  z-index: 1;
}
.select-withicon .ant-select-selector .ant-select-selection-search,
.select-withicon .ant-select-selector .ant-select-selection-placeholder,
.select-withicon .ant-select-selector .ant-select-selection-item {
  padding-left: 30px;
}

.no-arrow input[type=number]::-webkit-inner-spin-button,
.no-arrow input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.custom-steps.ant-steps {
  width: calc(100% + 40px);
  margin: 0 -20px;
}
.custom-steps.ant-steps .ant-steps-item-custom .ant-steps-item-container {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.custom-steps.ant-steps .ant-steps-item-custom .ant-steps-item-icon {
  width: 40px;
  height: 40px;
  margin: 0;
  line-height: 20px;
  border: 0;
  border-radius: 50%;
  overflow: hidden;
  background: none;
}
.custom-steps.ant-steps .ant-steps-item-custom .ant-steps-item-icon .ant-steps-icon {
  background: #2c2c2c;
  position: relative;
  font-size: 20px;
  width: 40px;
  height: 40px;
  line-height: 40px;
  left: 0;
  display: inline-block;
  z-index: 1;
  color: #fff;
}
.custom-steps.ant-steps .ant-steps-item-custom .ant-steps-item-icon::after {
  content: "";
  position: absolute;
  top: 18.5px;
  left: auto;
  right: 50%;
  display: block;
  width: 100%;
  height: 3px;
  border-top: 3px solid #2c2c2c;
}
.custom-steps.ant-steps .ant-steps-item-custom .ant-steps-item-description {
  text-align: center;
  padding: 0 4px;
  margin-top: 10px;
  line-height: 20px;
  color: #7D858F;
}
.custom-steps.ant-steps .ant-steps-item-custom:first-child .ant-steps-item-icon::after {
  content: none;
}
.custom-steps.ant-steps .ant-steps-item-custom:last-child {
  flex: 1;
}
.custom-steps.ant-steps .ant-steps-item-finish .ant-steps-item-icon > .ant-steps-icon {
  background: #02a574;
  color: #fff;
}
.custom-steps.ant-steps .ant-steps-item-finish .ant-steps-item-icon:after {
  border-color: #02a574;
}
.custom-steps.ant-steps .ant-steps-item-finish .ant-steps-item-description {
  color: #bebebe;
}
.custom-steps.ant-steps .ant-steps-item-process .ant-steps-item-icon > .ant-steps-icon {
  background: #c3423f;
  color: #fff;
}
.custom-steps.ant-steps .ant-steps-item-process .ant-steps-item-icon:after {
  border: 2px dashed #c3423f;
}
.custom-steps.ant-steps .ant-steps-item-process .ant-steps-item-description {
  color: #bebebe;
}
.custom-steps.ant-steps .ant-steps-item {
  padding: 0;
  overflow: unset;
}
.custom-steps.ant-steps .ant-steps-item-title::after {
  content: none;
}

.notitle-step.ant-steps {
  width: 100%;
  margin: 0;
}
.notitle-step.ant-steps .ant-steps-item-custom:first-child .ant-steps-item-container {
  align-items: flex-start;
}
.notitle-step.ant-steps .ant-steps-item-custom:last-child .ant-steps-item-container {
  align-items: flex-end;
}

.custom-collapse .ant-collapse-item {
  margin-bottom: 16px;
}

.dashboard-grid-ui .ant-card-body {
  padding: 40px 30px;
}

.ant-card-bordered {
  border-radius: 12px;
}

.my-breadcrumb-item {
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 3px 11px;
  gap: 10px;
  width: 53px;
  height: 21px;
  /* Grey/Grey 100 */
  background: #F5F5F5;
  border-radius: 9.5px;
  /* Inside auto layout */
  flex: none;
  order: 0;
  flex-grow: 0;
  font-size: 12px;
}

.ant-breadcrumb {
  margin-bottom: 30px;
}

.col-design {
  border: 1px solid rgba(141, 149, 160, 0.15);
  border-radius: 12px;
}

.col-design .ant-table-content {
  padding: 15px;
}

.col-design .ant-table-content tr th {
  font-size: 16px;
  font-weight: 600;
  color: #000C0F;
}

.col-design2 {
  border: 1px solid rgba(141, 149, 160, 0.15);
  border-radius: 12px;
}

.col-design2 .ant-table-content {
  padding: 15px;
}

.col-design2 .ant-table-content tr th {
  font-size: 14px;
  font-weight: 600;
  color: #000C0F;
}

.col-design3 {
  padding: 20px;
  height: 710px;
}

.col-design4 {
  padding: 20px;
}

.circleProgress {
  width: 100%;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 6.5em;
}
.circleProgress .ant-progress-inner {
  max-width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.percent-text {
  font-size: 34px;
  font-weight: 500;
}
.percent-text span {
  font-size: 15px;
  font-weight: 400;
}

.percent-numb {
  font-size: 15px;
  font-weight: 400;
  width: 100%;
  margin-top: 10px;
}

.card-text {
  padding: 20px;
  background-color: #0e0e0e;
  border-radius: 8px;
  text-align: center;
  width: 100%;
}

.divDisable {
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  z-index: 1;
}

.disableBody .ant-tabs-tabpane {
  position: relative;
}

.ant-form-item-control-input-content button.ant-btn.ant-btn-text {
  position: absolute;
  z-index: 9999;
  right: 0;
  top: 6px;
  padding: 0 10px;
}

.landing-layout {
  width: 100%;
  overflow: hidden;
}
.landing-layout .ant-row-middle {
  min-height: 100vh;
}

.login-layout {
  width: 100%;
  overflow: hidden;
}
.login-layout .ant-row-middle {
  padding: 100px 24px 24px 24px;
  min-height: 100vh;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/base/_typography.scss","webpack://./src/assets/styles/styles.scss","webpack://./src/assets/styles/layout/_header.scss","webpack://./src/assets/styles/base/_colors.scss","webpack://./src/assets/styles/layout/_main.scss","webpack://./src/assets/styles/partials/_menu.scss","webpack://./src/assets/styles/partials/_common.scss","webpack://./src/assets/styles/partials/_cards.scss","webpack://./src/assets/styles/base/_spaces.scss","webpack://./src/assets/styles/partials/_reqCard.scss","webpack://./src/assets/styles/partials/_tabs.scss","webpack://./src/assets/styles/partials/_table.scss","webpack://./src/assets/styles/partials/_forms.scss","webpack://./src/assets/styles/partials/_steps.scss","webpack://./src/assets/styles/partials/_collapse.scss","webpack://./src/assets/styles/partials/_dashboard.scss","webpack://./src/assets/styles/pages/_marketing.scss","webpack://./src/assets/styles/pages/_landing.scss","webpack://./src/assets/styles/pages/_login.scss"],"names":[],"mappings":"AAAA;EACE,0BAAA;EACA,4BAAA;ACEF;;ADCA;EACE,eAAA;EACA,iBAAA;ACEF;;ADCA;EACE,0BAAA;EACA,4BAAA;ACEF;;ADCA;EACE,0BAAA;EACA,2BAAA;ACEF;;ADCA;EACE,0BAAA;EACA,2BAAA;ACEF;;ADAA;EACE,0BAAA;EACA,2BAAA;ACGF;;ADDA;EACE,0BAAA;EACA,2BAAA;ACIF;;ADFA;EACE,0BAAA;EACA,2BAAA;ACKF;;ADFA;EACE,0BAAA;ACKF;;ADFA;EACE,0BAAA;ACKF;;ADFA;EACE,0BAAA;ACKF;;ADFA;EACE,0BAAA;ACKF;;ADHA;EACE,0BAAA;ACMF;;ADHA;EACE,0BAAA;ACMF;;ADJA;EACE,0BAAA;ACOF;;ADJA;EACE,0BAAA;EACA,iBAAA;EACA,gBAAA;ACOF;;ADJA;EACE,4BAAA;ACOF;;ADJA;EACE,4BAAA;ACOF;;ADJA;EACE,gBAAA;ACOF;;ADJA;EACE,qCAAA;ACOF;;ADJA;;EAEE,gBAAA;EACA,eAAA;ACOF;;ADJA;;EAEE,gBAAA;ACOF;;ADJA;;EAEE,gBAAA;ACOF;;ADJA;;EAEE,gBAAA;EACA,mBAAA;EACA,cAAA;ACOF;;ADJA;;EAEE,gBAAA;EACA,mBAAA;EACA,cAAA;ACOF;;ADJA;EACE,kBAAA;ACOF;;ADJA;EACE,0BAAA;ACOF;;ADJA;EACE,sBAAA;ACOF;;ADJA;EACE,yBAAA;ACOF;;ADHA;EACE,yBAAA;ACMF;;ADHA;EACE,cAAA;ACMF;;ADHA;EACE,2BAAA;ACMF;;ADHA;EACE,2BAAA;ACMF;;ADHA;EACE,2BAAA;ACMF;;ADHA;EACE,0BAAA;ACMF;;ADJA;EACE,eAAA;ACOF;;ADLA;EACE,kBAAA;ACQF;;ACvKA;EACI,uBAAA;EACA,eAAA;EACA,WAAA;EACA,UAAA;AD0KJ;ACzKI;EACI,4BAAA;AD2KR;;ACtKI;EACI,WAAA;ADyKR;ACvKI;EACI,WAAA;ADyKR;ACtKQ;EACI,WAAA;ADwKZ;;ACnKA;EACI,WAAA;ADsKJ;;ACnKA;EACI,mBC1Bc;ED2Bd,uBAAA;EACA,YAAA;ADsKJ;ACrKI;EACI,cC5BD;AFmMP;ACrKI;EACI,mBCjCU;AFwMlB;ACrKI;EACI,kBAAA;ADuKR;;AG9MA;EACE,UAAA;AHiNF;AGhNE;EACE,SAAA;AHkNJ;;AG9MA;EACE,UAAA;EACA,aAAA;AHiNF;;AG9MA;EACE,mBAAA;EACA,4CAAA;EACA,8BAAA;AHiNF;;AG9MA;EACE,iCAAA;EACA,gBAAA;EACA,4BAAA;AHiNF;;AG9ME;EADF;IAEI,2BAAA;EHkNF;AACF;AGhNE;EALF;IAMI,2BAAA;EHmNF;AACF;AGjNE;EATF;IAUI,6BAAA;EHoNF;AACF;;AGjNA;EACE,uBAAA;AHoNF;;AGjNA;EACE,aAAA;EACA,cAAA;EACA,4DAAA;AHoNF;;AGjNA;EACE,aAAA;AHoNF;AGnNE;EAFF;IAGI,eAAA;EHsNF;AACF;;AGnNA;EACE,YAAA;EACA,gBAAA;EACA,gBAAA;EACA,mBAAA;AHsNF;AGrNE;EALF;IAMI,gBAAA;EHwNF;AACF;AGvNE;EARF;IASI,WAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;IACA,oBAAA;EH0NF;AACF;;AGvNA;EACE,YAAA;EACA,eAAA;AH0NF;AGzNE;EAHF;IAII,WAAA;EH4NF;AACF;AG3NE;EANF;IAOI,WAAA;EH8NF;AACF;;AG3NA;EACE,sBAAA;AH8NF;;AG3NA;EACE,gCAAA;AH8NF;;AG3NA;EACE,iCAAA;AH8NF;;AIzTA;EACE,kCAAA;EACA,YAAA;AJ4TF;AI1TI;EACE,iBAAA;AJ4TN;AIzTE;EACE,8BAAA;AJ2TJ;AI1TI;EACE,gBAAA;EACA,cAAA;AJ4TN;AI1TI;EACE,aFEM;EEDN,eFCM;EEAN,aAAA;AJ4TN;AI1TI;EACE,oBAAA;EACA,UAAA;AJ4TN;;AIvTA;EACE,kBAAA;EACA,2BAAA;EACA,mBAAA;EACA,6BAAA;EACA,uBAAA;AJ0TF;AIzTE;EACE,gBAAA;EACA,cF7BG;AFwVP;AIzTE;EACE,mBFnCa;AF8VjB;AIrTA;EACE,eF7BY;AFoVd;;AIrTA;EACE,gBAAA;AJwTF;;AItTA;;;;;;EAME,yBAAA;EACA,UAAA;EACA,eAAA;AJyTF;;AItTA;EACE,6BAAA;AJyTF;AIxTE;EACE,cAAA;AJ0TJ;AIxTE;EACE,cAAA;AJ0TJ;AIvTI;EACE,2BAAA;AJyTN;;AIpTA;EACE,kBAAA;EACA,0BAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,kBAAA;AJuTF;AItTE;EACE,YAAA;EACA,uBAAA;AJwTJ;;AInTE;EACE,UAAA;EACA,uBAAA;AJsTJ;;AIjTE;EACE,kBAAA;EACA,6BAAA;EACA,uBAAA;EACA,sBAAA;EACA,4BAAA;AJoTJ;AInTI;EACE,0BAAA;EACA,yBAAA;AJqTN;AIlTE;EACE,cAAA;EACA,gBAAA;EACA,WAAA;AJoTJ;;AI/SE;EACE,kBAAA;EACA,cAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,gCAAA;AJkTJ;AIhTE;EACE,YAAA;AJkTJ;;AI7SE;EACE,gCAAA;EACA,wCAAA;AJgTJ;AI9SE;EACE,gCAAA;AJgTJ;;AKtbA;;;;;;;;;EAUE,SAAA;EACA,uCAAA;EACA,+CAAA;EACA,2CAAA;ALwbF;;AKrbA;EACE,wBAAA;ALwbF;;AKrbA;EACE,yBAAA;ALwbF;;AKrbA;EACE,gCAAA;ALwbF;;AKrbA;EACE,sBAAA;ALwbF;;AKrbA;EACE,gBAAA;ALwbF;;AKrbA;EACE,YAAA;ALwbF;;AKrbA;EACE,uBAAA;ALwbF;;AKrbA;EACE,wBAAA;ALwbF;;AKtbA;EACE,6BAAA;ALybF;;AKtbA;EACE,4BAAA;ALybF;;AKvbA;EACE,2BAAA;AL0bF;;AKxbA;EACE,yBAAA;AL2bF;;AKzbA;EACE,uBAAA;AL4bF;;AKzbA;EACE,kBAAA;AL4bF;;AKzbA;EACE,8BAAA;AL4bF;;AKzbA;EACE,kBAAA;EACA,MAAA;EACA,WAAA;AL4bF;;AKzbA;EACE,qBAAA;AL4bF;;AK1bA;EACE,6BAAA;EACA,8BAAA;AL6bF;;AK1bA;EACE,6BAAA;EACA,8BAAA;AL6bF;;AK1bA;EACE,yBAAA;EACA,4BAAA;AL6bF;;AK1bA;EACE,oBAAA;AL6bF;;AK1bA;EACE,2BAAA;AL6bF;;AK3bA;EACE,iBAAA;EACA,oBAAA;AL8bF;;AK3bA;EACE,iBAAA;EACA,oBAAA;AL8bF;;AK3bA;EACE,8BAAA;AL8bF;;AK3bA;EACE,2BAAA;AL8bF;;AK3bA;EACE,wBAAA;AL8bF;;AK3bA;EACE,2BAAA;AL8bF;;AK3bA;EACE,8BAAA;AL8bF;;AK3bA;EACE,8BAAA;AL8bF;;AK3bA;EACE,8BAAA;AL8bF;;AK3bA;EACE,2BAAA;AL8bF;;AK3bA;EACE,2BAAA;AL8bF;;AK3bA;EACE,2BAAA;AL8bF;;AK3bA;EACE,2BAAA;AL8bF;;AK3bA;EACE,2BAAA;AL8bF;;AK3bA;EACE,iBAAA;AL8bF;;AK3bA;EACE,6BAAA;AL8bF;;AK5bA;EACE,6BAAA;AL+bF;;AK5bA;EACE,6BAAA;AL+bF;;AK5bA;EACE,yBAAA;AL+bF;;AK5bA;EACE,yBAAA;AL+bF;;AK7bA;EACE,yBAAA;ALgcF;;AK7bA;EACE,sBAAA;ALgcF;;AK7bA;EACE,cHhMK;AFgoBP;;AK7bA;EACE,YAAA;EACA,iBAAA;ALgcF;;AK7bA;EACE,cHpMK;EGqML,YAAA;EACA,iBAAA;ALgcF;AK/bE;EAEE,WAAA;ALgcJ;;AK5bA;EACE,aAAA;EACA,mBAAA;EACA,cH9MY;EG+MZ,iBAAA;AL+bF;AK9bE;EAEE,WAAA;AL+bJ;;AK3bA;EACE,sBAAA;EACA,uBAAA;EACA,qBAAA;EACA,gBAAA;EACA,0BAAA;EACA,cAAA;EACA,sBAAA;EACA,SAAA;EACA,yBAAA;AL8bF;AK7bE;EACE,eAAA;AL+bJ;AK7bE;EAEE,yBAAA;AL8bJ;;AK3bA;EACE,yBAAA;AL8bF;AK7bE;EAEE,yBAAA;AL8bJ;;AK1bA;EACE,oBAAA;AL6bF;;AK1bA;EACE,yBHjPU;EGkPV,SAAA;AL6bF;;AK1bA;EACE,yBAAA;AL6bF;;AK1bA;EACE,WAAA;EACA,yBH/PY;AF4rBd;;AK1bA;EACE,yBAAA;AL6bF;;AK1bA;EACE,yBHpQW;EGqQX,WAAA;AL6bF;;AK1bA;EACE,oCAAA;AL6bF;;AK1bA;EACE,yBHnRc;AFgtBhB;;AK1bA;EACE,mBHxRgB;AFqtBlB;;AK1bA;EACE,yBAAA;AL6bF;;AK1bA;EACE,sBAAA;EACA,oCAAA;AL6bF;AK5bE;EACE,WAAA;AL8bJ;;AK1bA;EACE,WAAA;EACA,yBHjSU;AF8tBZ;;AK1bA;EACE,WAAA;EACA,yBHjTK;AF8uBP;;AK1bA;EACE,cHrTK;AFkvBP;;AK1bA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,qBAAA;AL6bF;AK5bE;EACE,iBAAA;EACA,cHjTU;EGkTV,iBAAA;AL8bJ;;AK1bA;EACE,2BAAA;AL6bF;;AK1bA;EACE,0BAAA;AL6bF;;AK1bA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,eAAA;AL6bF;AK5bE;EACE,yBAAA;EACA,cHvUU;EGwUV,iBAAA;AL8bJ;;AK1bA;EACE,WAAA;EACA,gBAAA;EACA,UAAA;EACA,cAAA;AL6bF;AK5bE;EACE,0BAAA;AL8bJ;AK5bE;EACE,cH9VU;AF4xBd;;AK1bA;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,0BAAA;AL6bF;;AK1bA;EACE,2CAAA;AL6bF;;AK1bA;EACE,gCAAA;AL6bF;;AK1bA;EACE,YAAA;EACA,mBAAA;AL6bF;;AK1bA;EACE,eAAA;AL6bF;;AK1bA;EACE,YAAA;AL6bF;;AK1bA;EACE,YAAA;AL6bF;;AK1bA;EACE,YAAA;AL6bF;;AK1bA;EACE,YAAA;AL6bF;;AK1bA;EACE,YAAA;AL6bF;;AK1bA;EACE,YAAA;AL6bF;;AK1bA;EACE,YAAA;AL6bF;;AK1bA;EACE,YAAA;AL6bF;;AK1bA;EACE,YAAA;AL6bF;;AK1bA;EACE,UAAA;EACA,SAAA;EACA,qBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,cHraY;AFk2Bd;AK5bE;EACE,WAAA;AL8bJ;;AK1bA;EACE,uBAAA;EACA,kBAAA;EACA,WAAA;AL6bF;AK5bE;EAEE,gBAAA;EACA,kBAAA;EACA,cH1aU;AFu2Bd;AK3bE;EACE,gBAAA;EACA,kBAAA;AL6bJ;;AKzbA;EACE,mBH3bY;EG4bZ,qBH5bY;AFw3Bd;AK3bE;EAEE,mBH9bS;EG+bT,qBH/bS;AF23Bb;AK1bE;EACE,mBHjcW;EGkcX,qBHlcW;AF83Bf;;AKxbA;EACE,gBAAA;EACA,kBAAA;AL2bF;AK1bE;EAEE,gBAAA;EACA,kBAAA;AL2bJ;AKzbE;EACE,mBAAA;EACA,qBAAA;AL2bJ;;AKvbA;EACE,mBHldO;EGmdP,qBHndO;AF64BT;AKzbE;EAEE,mBHrdU;EGsdV,qBHtdU;AFg5Bd;AKxbE;EACE,mBHzdU;EG0dV,qBH1dU;AFo5Bd;;AKtbA;EACE,mBHteY;EGueZ,qBHveY;AFg6Bd;AKxbE;EAEE,WAAA;EACA,mBH3eU;EG4eV,qBH5eU;AFq6Bd;AKvbE;EACE,WAAA;EACA,mBHhfU;EGifV,qBHjfU;AF06Bd;;AKrbA;EACE,eAAA;ALwbF;;AKrbA;EACE,iBAAA;ALwbF;AKpbQ;EACE,cHpgBG;AF07Bb;AKnbM;EACE,aAAA;ALqbR;AKjbE;EACE,kBAAA;EACA,gBAAA;ALmbJ;AKlbI;EACE,SAAA;ALobN;AKjbM;EACE,wBAAA;EACA,yBHphBS;EGqhBT,kBAAA;ALmbR;AK/aM;EACE,aAAA;ALibR;;AK3aA;EACE,aAAA;EACA,kBAAA;AL8aF;AK7aE;EACE,eAAA;AL+aJ;AK9aI;EACE,gBAAA;ALgbN;AK7aM;EACE,sBAAA;AL+aR;;AKzaA;EACE,aAAA;AL4aF;;AKxaE;EACI,yBAAA;EACA,kBAAA;AL2aN;;AKvaA;EACE,kBAAA;EACA,WAAA;EACA,UAAA;EACA,QAAA;EACA,UAAA;AL0aF;;AKvaA;EACE,iBAAA;AL0aF;AKzaE;EACE,UAAA;AL2aJ;;AKvaA;EACE,aAAA;EACA,eAAA;EACA,6BAAA;EACA,WAAA;AL0aF;AKzaE;EACE,SAAA;EACA,cAAA;AL2aJ;AK1aI;EACE,cAAA;AL4aN;;AKtaA;EACE,eAAA;EACA,gBAAA;ALyaF;;AKlaA;;EAGE,gBAAA;ALoaF;;AKjaA;EACE,kBAAA;ALoaF;;AKjaA;;EAEE,eAAA;ALoaF;;AKjaA;EAEE,aAAA;ALmaF;;AKhaA;EAEE,qBAAA;EACA,gBAAA;EACA,cHhnBO;EGinBP,eAAA;EACA,+BAAA;EACA,cAAA;EACA,YAAA;ALkaF;;AK/ZA;EACE,qBHpoBK;AFsiCP;;AK/ZA;EACE,WAAA;EACA,YAAA;ALkaF;;AK/ZA;EACE,6BAAA;ALkaF;;AK/ZA;EACE,oBAAA;ALkaF;;AKhaA;EACE,mBAAA;ALmaF;;AKjaA;EACE,WAAA;ALoaF;;AKlaA;EACE,kBAAA;EACA,mBAAA;ALqaF;;AKnaA;EACE,oBAAA;ALsaF;;AKlaE;EACE,UAAA;EACA,SAAA;EACA,eAAA;ALqaJ;AKnaE;EACE,wBAAA;EACA,iBAAA;EACA,6BAAA;ALqaJ;;AKjaA;EACE,aAAA;EACA,8BAAA;ALoaF;;AKhaE;EACE,WAAA;ALmaJ;;AKhaA;EACE,WAAA;EACA,aAAA;ALmaF;;AKjaA;EACE,WAAA;EACA,aAAA;ALoaF;;AKlaA;EACE,cHjsBK;EGksBL,qBHlsBK;AFumCP;;AKlaA;EACE,cAAA;EACA,eAAA;ALqaF;;AKlaA;EACE,iBAAA;EACA,eAAA;ALqaF;;AKlaA;EACE,UAAA;EACA,cAAA;ALqaF;;AKlaA;EACE,iCAAA;EACA,gDAAA;EACA,2BAAA;EACA,iBAAA;ALqaF;;AKlaA;EAEE,eAAA;ALoaF;;AKjaA;EACE,WAAA;ALoaF;;AKhaE;EACE,eAAA;ALmaJ;;AK/ZA;EACE,eAAA;ALkaF;;AK/ZA;EACE,8BAAA;EACA,8BAAA;ALkaF;;AK/ZA;EACE,WAAA;ALkaF;;AKhaA;EACE,sBAAA;EACA,yBAAA;ALmaF;;AKhaA;EACI,gDAAA;EACA,4BAAA;EACA,kBAAA;ALmaJ;;AKjaA;EACE,WAAA;EACA,MAAA;ALoaF;AKnaE;EACE,UAAA;ALqaJ;AKpaI;EACE,6BAAA;EACA,UAAA;EACA,gBAAA;EACA,cAAA;ALsaN;AKpaM;EACE,cAAA;EACA,aAAA;ALsaR;AKpaQ;EACE,kCAAA;ALsaV;AKpaU;EACE,WAAA;ALsaZ;AKlaQ;EACE,kCAAA;ALoaV;AKlaU;EACE,WAAA;ALoaZ;;AK1ZA;EACE,qBAAA;EACA,oBAAA;AL6ZF;AK3ZE;EACE,oBAAA;AL6ZJ;;AKtZM;EACE,wBAAA;ALyZR;AKpZE;EACE,wBAAA;ALsZJ;;AKnZA;EACE,aAAA;ALsZF;;AK7YA;EACE,yBAAA;EACA,oBAAA;EACA,gBAAA;EACA,eAAA;ALgZF;;AK9YA;EACE,qBAAA;ALiZF;;AK9YE;EACE,kBAAA;ALiZJ;;AK5YI;EACE,wBAAA;EACA,mBAAA;EACA,YAAA;EACA,oBAAA;AL+YN;;AKzYE;EACE,yBAAA;AL4YJ;;AKzYA;EACE,yBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;AL4YF;;AKzYA;EACE,YAAA;AL4YF;;AKxYE;EACE,WAAA;AL2YJ;;AKtYE;EACE,YAAA;EACA,WAAA;ALyYJ;;AKrYA;EACE,gBAAA;EACA,eAAA;ALwYF;;AKrYA;EACE,kBAAA;ALwYF;;AKrYA;EACE,cAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,wCAAA;ALwYF;;AKrYA;EACE,gBAAA;EACA,oBAAA;ALwYF;;AKrYA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;ALwYF;;AKrYA;EACE,kBAAA;EACA,YAAA;EACA,qBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,8BAAA;ALwYF;;AKrYA;EACE,kBAAA;EACA,mBAAA;ALwYF;;AKpYE;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;ALuYJ;;AKnYA;EACE,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,gBAAA;EACA,mBAAA;ALsYF;;AKpYA;EACE,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,mBAAA;ALuYF;;AKpYA;EACI,kBAAA;EACA,yDAAA;EACA,yBAAA;ALuYJ;;AKnYA;EACE,yBAAA;ALsYF;;AKnYA;EACE,gBAAA;EACA,mBAAA;ALsYF;;AKpYA;EACE,oBAAA;EACA,mBAAA;EACA,QAAA;EACA,kBAAA;EACA,kBAAA;EACA,mCAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,yCAAA;EACA,8CAAA;EACA,cAAA;EACA,gBAAA;EACA,kBAAA;ALuYF;;AMj2CA;EAGE,uBAAA;ANk2CF;AMj2CE;EACE,kBAAA;ANm2CJ;AMl2CI;EAFF;IAGI,kBAAA;ENq2CJ;AACF;AMp2CI;EALF;IAMI,kBAAA;ENu2CJ;AACF;;AMl2CE;EAEE,aAAA;ANo2CJ;;AMh2CA;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,2EAAA;ANm2CF;AMl2CE;EACE,kBAAA;EACA,aC1Ba;AP83CjB;AMn2CI;EAHF;IAII,aCtBW;EP43Cf;AACF;AMr2CI;EANF;IAOI,aCpBW;EP43Cf;AACF;;AMp2CA;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,WAAA;ANu2CF;AMr2CE;EACE,kBAAA;EACA,aC5Ca;APm5CjB;AMt2CI;EAHF;IAII,aCxCW;EPi5Cf;AACF;AMx2CI;EANF;IAOI,aCtCW;EPi5Cf;AACF;;AMv2CA;EACE,YAAA;EACA,mBAAA;EACA,gBAAA;EACA,2EAAA;AN02CF;AMz2CE;EACE,kBAAA;EACA,kBAAA;EACA,iBAAA;EACA,mBAAA;AN22CJ;AMz2CI;EANF;IAOI,aC5DW;EPw6Cf;AACF;AM32CI;EATF;IAUI,aC1DW;EPw6Cf;AACF;;AMz2CA;EACE,2BAAA;AN42CF;AM32CE;EACE,YAAA;AN62CJ;;AMx2CA;EACE,WAAA;EACA,kBAAA;EACA,uBAAA;AN22CF;AM12CE;EACE,yBAAA;AN42CJ;;AMx2CA;EACE,WAAA;EACA,kBAAA;EACA,uBAAA;AN22CF;AM12CE;EACE,wBAAA;AN42CJ;;AMx2CA;EACE,YAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;EACA,wBAAA;EACA,yBAAA;AN22CF;;AMz2CA;EACE,WAAA;EACA,6BAAA;EACA,mBAAA;AN42CF;AM32CE;EACE,UAAA;AN62CJ;;AMz2CA;EACE,WAAA;EACA,YAAA;EACA,gBAAA;EACA,8BAAA;EACA,6BAAA;EACA,kBAAA;AN42CF;AM32CE;EACE,eAAA;AN62CJ;;AMv2CA;EACE,mBAAA;EACA,yBAAA;EACA,mBAAA;AN02CF;;AMv2CA;EACE,YAAA;EACA,kBAAA;AN02CF;AMz2CE;EACE,aAAA;AN22CJ;AMz2CE;EACE,eAAA;AN22CJ;;AMv2CA;EACE,YAAA;EACA,kBAAA;AN02CF;AMz2CE;EACE,kBAAA;EACA,mBAAA;EACA,iBAAA;EACA,mBAAA;AN22CJ;AMz2CE;EACE,eAAA;AN22CJ;;AMv2CA;EACE,gBAAA;AN02CF;AMz2CE;EACE,aCrKY;APghDhB;;AMv2CA;EACE,YAAA;AN02CF;AMz2CE;EACE,yBAAA;EACA,aAAA;EACA,iBAAA;EACA,8BAAA;AN22CJ;;AMr2CA;EACE,kCAAA;EACA,WAAA;EACA,2BAAA;ANw2CF;AMv2CE;EACE,UAAA;ANy2CJ;;AMr2CA;EACE,kCAAA;EACA,WAAA;EACA,sBAAA;EACA,2BAAA;ANw2CF;AMv2CE;EACE,UAAA;ANy2CJ;;AMr2CA;EACE,uBAAA;ANw2CF;;AMt2CA;EACE,uBAAA;ANy2CF;;AMv2CA;EACE,uBAAA;AN02CF;;AMv2CE;EACE,cAAA;AN02CJ;;AM/1CE;EACE,mBAAA;ANk2CJ;AMh2CE;EACE,aAAA;EACA,sBAAA;EACA,kBAAA;ANk2CJ;AMj2CI;EACE,WAAA;EACA,gBAAA;EACA,eAAA;ANm2CN;AMj2CI;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;ANm2CN;AMj2CI;EACE,SAAA;EACA,iBAAA;ANm2CN;AMh2CE;EACE,WAAA;EACA,gBAAA;ANk2CJ;;AQ3lDE;EACG,6CAAA;AR8lDL;AQzlDE;EACE,uBAAA;AR2lDJ;ASnmDA;EACE,eAAA;ATqmDF;ASjmDQ;EADF;IAEI,WAAA;ETomDR;AACF;ASnmDQ;EAJF;IAKI,UAAA;ETsmDR;AACF;AS5mDM;EAOE,YAAA;EACA,kBAAA;ATwmDR;ASvmDQ;EACE,WAAA;EACA,YAAA;EACA,6BAAA;EACA,uBAAA;ATymDV;ASvmDQ;EACE,WAAA;EACA,mBAAA;ATymDV;ASnmDE;;EAEE,SAAA;ATqmDJ;AS3lDE;EACE,mBFrCa;APkoDjB;;ASxlDE;EACE,eAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,yBPvCQ;EOwCR,WAAA;AT2lDJ;;AStlDE;EACE,WAAA;EACA,YAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,yBP/CU;EOgDV,WAAA;EACA,UAAA;ATylDJ;;ASrlDA;EACE,kBAAA;ATwlDF;AStlDI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;ATwlDN;ASvlDM;EACE,cPvED;AFgqDP;ASvlDM;EACE,cP1ED;EO2EC,gBAAA;EACA,eAAA;EACA,gBAAA;ATylDR;ASvlDM;EACE,eAAA;ATylDR;AStlDI;EACE,aAAA;ATwlDN;AStlDI;EACE,6BAAA;EACA,eAAA;EACA,gBAAA;ATwlDN;ASvlDM;EACE,WAAA;ATylDR;ASvlDM;EACE,WAAA;EACA,eAAA;EACA,gBAAA;ATylDR;AStlDQ;EACE,yBP7FD;AFqrDT;ASllDI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;ATolDN;ASnlDM;EACE,cP/GD;AFosDP;ASnlDM;EACE,cPlHD;EOmHC,eAAA;EACA,gBAAA;ATqlDR;ASllDI;EACE,aAAA;ATolDN;ASllDI;EACE,eAAA;EACA,gBAAA;EACA,6BAAA;ATolDN;ASnlDM;EACE,WAAA;ATqlDR;ASnlDM;EACE,WAAA;EACA,eAAA;EACA,gBAAA;ATqlDR;;AS/kDA;EAEE,SAAA;EACA,QAAA;ATilDF;AShlDE;EACE,SAAA;EACA,eAAA;EACA,cAAA;EACA,mBPpJc;AFsuDlB;AShlDE;EACE,SAAA;ATklDJ;AShlDE;EACE,aAAA;ATklDJ;;AS/kDA;EACE,kBAAA;EAEA,MAAA;EACA,yBAAA;EACA,WAAA;ATilDF;;AS/kDA;EACE,eAAA;ATklDF;AShlDI;EACE,eAAA;ATklDN;AS/kDM;EACE,UAAA;EACA,yBAAA;ATilDR;AShlDQ;EACE,WAAA;EACA,2CAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,uBAAA;ATklDV;ASjlDU;EACE,YAAA;ATmlDZ;ASjlDU;EACE,YAAA;EACA,uBAAA;EACA,4CAAA;ATmlDZ;ASllDY;EACE,YAAA;ATolDd;AS5kDE;;EAEE,SAAA;AT8kDJ;AS5kDE;;EAEE,WAAA;EACA,yBPjNG;AF+xDP;;AS3kDA;EACE,eAAA;AT8kDF;AS5kDI;EACE,eAAA;AT8kDN;AS3kDM;EACE,UAAA;EACA,yBAAA;AT6kDR;AS5kDQ;EACE,WAAA;EACA,2CAAA;EACA,YAAA;EACA,6BAAA;EACA,kBAAA;EACA,uBAAA;EACA,uBAAA;AT8kDV;AS7kDU;EACE,+CAAA;EACA,qBAAA;AT+kDZ;ASzkDE;;EAEE,SAAA;AT2kDJ;;ASvkDE;EACE,6BAAA;EACA,yBAAA;EACA,oBAAA;AT0kDJ;;AUh0DE;;EAEE,gBAAA;EACA,cAAA;EACA,2BAAA;AVm0DJ;AUj0DE;EACE,cRUc;EQTd,yBRPa;AF00DjB;AUzzDA;EACE,yBAAA;AV2zDF;;AUzzDA;EACE,aAAA;EACA,WAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;AV4zDF;AU3zDE;EACE,cRxBG;EQyBH,WAAA;EACA,kBAAA;EACA,SAAA;EACA,kBAAA;AV6zDJ;AU5zDI;EACE,aAAA;AV8zDN;AU5zDI;EACE,WAAA;AV8zDN;;AUxzDE;EACE,wCAAA;AV2zDJ;AU1zDI;EACE,wCAAA;EACA,2CAAA;AV4zDN;;AW32DE;EACE,UAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,sBAAA;EACA,8BAAA;AX82DJ;AW72DI;EACE,cAAA;EACA,iBAAA;EACA,eAAA;AX+2DN;AW52DE;EACE,MAAA;AX82DJ;AW52DE;EACE,kBAAA;AX82DJ;AW32DI;EACE,aAAA;AX62DN;;AWv2DE;;;EAGE,qBT3BU;AFq4Dd;AWx2DE;;;;EAIE,qBTpCc;ESqCd,mBTrCc;AF+4DlB;AWx2DE;EACE,qBTxCc;AFk5DlB;AWx2DE;EACE,qBTzCG;AFm5DP;;AWt2DA;EACE,mBAAA;AXy2DF;AWx2DE;EACE,eAAA;EACA,iBAAA;AX02DJ;;AWr2DE;EACE,yBTjDQ;AFy5DZ;;AWn2DE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,eAAA;EACA,UAAA;AXs2DJ;AWn2DI;;;EAGE,kBAAA;AXq2DN;;AWh2DE;;EAEI,wBAAA;EACA,SAAA;AXm2DN;;AYt7DI;EACI,wBAAA;EACA,eAAA;AZy7DR;AYv7DY;EACI,aAAA;EACA,sBAAA;EACA,mBAAA;AZy7DhB;AYv7DY;EACI,WAAA;EACA,YAAA;EACA,SAAA;EACA,iBAAA;EACA,SAAA;EACA,kBAAA;EACA,gBAAA;EACA,gBAAA;AZy7DhB;AYx7DgB;EACI,mBVTR;EUUQ,kBAAA;EACA,eAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,OAAA;EACA,qBAAA;EACA,UAAA;EACA,WAAA;AZ07DpB;AYx7DgB;EACI,WAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,UAAA;EACA,cAAA;EACA,WAAA;EACA,WAAA;EACA,6BAAA;AZ07DpB;AYr7DY;EACI,kBAAA;EACA,cAAA;EACA,gBAAA;EACA,iBAAA;EACA,cV7CT;AFo+DP;AYn7DoB;EACI,aAAA;AZq7DxB;AYj7DY;EACI,OAAA;AZm7DhB;AY96DgB;EACI,mBV3DN;EU4DM,WAAA;AZg7DpB;AY96DgB;EACI,qBV/DN;AF++Dd;AY76DY;EACI,cVpEF;AFm/Dd;AY16DgB;EACI,mBVpEX;EUqEW,WAAA;AZ46DpB;AY16DgB;EACI,0BAAA;AZ46DpB;AYz6DY;EACI,cVlFF;AF6/Dd;AYv6DQ;EACI,UAAA;EACA,eAAA;AZy6DZ;AYv6DQ;EACI,aAAA;AZy6DZ;;AYj6DI;EACI,WAAA;EACA,SAAA;AZo6DR;AYj6DgB;EACI,uBAAA;AZm6DpB;AY/5DgB;EACI,qBAAA;AZi6DpB;;AarhEA;EACE,mBAAA;AbwhEF;;AczhEA;EACI,kBAAA;Ad4hEJ;;AczhEA;EACI,mBAAA;Ad4hEJ;;AczhEA;EACI,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,UAAA;EACA,QAAA;EACA,YAAA;EACA,eAAA;Ad4hEJ;;AczhEA;EACI,mBAAA;Ad4hEJ;;AczhEA;EACI,2CAAA;EACA,mBAAA;Ad4hEJ;;AczhEA;EACI,aAAA;Ad4hEJ;;AczhEA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;Ad4hEJ;;AczhEA;EACI,2CAAA;EACA,mBAAA;Ad4hEJ;;AczhEA;EACI,aAAA;Ad4hEJ;;AczhEA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;Ad4hEJ;;AczhEA;EACI,aAAA;EACA,aAAA;Ad4hEJ;;AczhEA;EACI,aAAA;Ad4hEJ;;Ae9lEA;EACE,WAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;AfimEF;Ae/lEE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AfimEJ;;Ae7lEA;EACE,eAAA;EACA,gBAAA;AfgmEF;Ae9lEE;EACE,eAAA;EACA,gBAAA;AfgmEJ;;Ae5lEA;EACE,eAAA;EACA,gBAAA;EACA,WAAA;EACA,gBAAA;Af+lEF;;Ae5lEA;EACE,aAAA;EACA,yBbpBY;EaqBZ,kBAAA;EACA,kBAAA;EACA,WAAA;Af+lEF;;Ae5lEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,OAAA;EACA,MAAA;EACA,UAAA;Af+lEF;;Ae3lEE;EACE,kBAAA;Af8lEJ;;AezlEE;EACE,kBAAA;EACA,aAAA;EACA,QAAA;EACA,QAAA;EAEA,eAAA;Af2lEJ;;AgB1pEA;EACI,WAAA;EACA,gBAAA;AhB6pEJ;AgB5pEI;EACE,iBAAA;AhB8pEN;;AiBlqEA;EACI,WAAA;EACA,gBAAA;AjBqqEJ;AiBpqEI;EACE,6BAAA;EACA,iBAAA;AjBsqEN","sourcesContent":[".smallFont12 {\n  font-size: 12px !important;\n  line-height: 16px !important;\n}\n\n.smallFont14 {\n  font-size: 14px;\n  line-height: 22px;\n}\n\n.defaultFont {\n  font-size: 15px !important;\n  line-height: 22px !important;\n}\n\n.fontSize18Bold {\n  font-size: 18px !important;\n  font-weight: 700 !important;\n}\n\n.fontSize18Medium {\n  font-size: 18px !important;\n  font-weight: 500 !important;\n}\n.fontSize16Medium {\n  font-size: 16px !important;\n  font-weight: 600 !important;\n}\n.fontSize13Medium {\n  font-size: 13px !important;\n  font-weight: 600 !important;\n}\n.fontSize12Medium {\n  font-size: 12px !important;\n  font-weight: 600 !important;\n}\n\n.RegularFont {\n  font-size: 16px !important;\n}\n\n.fontSize20 {\n  font-size: 20px !important;\n}\n\n.ag-fontSize24 {\n  font-size: 24px !important;\n}\n\n.ag-fontSize26 {\n  font-size: 26px !important;\n}\n.ag-fontSize31 {\n  font-size: 31px !important;\n}\n\n.ag-fontSize32 {\n  font-size: 32px !important;\n}\n.fontSize40 {\n  font-size: 40px !important;\n}\n\n.ag-fontSize30 {\n  font-size: 30px !important;\n  line-height: 38px;\n  font-weight: 400;\n}\n\n.lineHeight20 {\n  line-height: 20px !important;\n}\n\n.lineHeight40 {\n  line-height: 40px !important;\n}\n\n.fontWeight600 {\n  font-weight: 600;\n}\n\n.Sentence {\n  text-transform: capitalize !important;\n}\n\nh1.ant-typography,\n.ant-typography h1 {\n  font-weight: 700;\n  font-size: 36px;\n}\n\nh2.ant-typography,\n.ant-typography h2 {\n  font-weight: 700;\n}\n\nh3.ant-typography,\n.ant-typography h3 {\n  font-weight: 700;\n}\n\nh4.ant-typography,\n.ant-typography h4 {\n  font-weight: 400;\n  margin-bottom: 20px;\n  color: #646777;\n}\n\nh5.ant-typography,\n.ant-typography h5 {\n  font-weight: 400;\n  margin-bottom: 20px;\n  color: #646777;\n}\n\n.text-italic {\n  font-style: italic;\n}\n\n.SentanceCase {\n  text-transform: capitalize;\n}\n\n.text-white {\n  color: #fff !important;\n}\n\n.text-grey {\n  color: #B4BBC3 !important;\n}\n\n\n.text-base {\n  color: $main-color !important;\n}\n\n.text-step {\n  color: #7D858F\n}\n\n.font-300 {\n  font-weight: 300 !important;\n}\n\n.font-400 {\n  font-weight: 400 !important;\n}\n\n.font-500 {\n  font-weight: 500 !important;\n}\n\n.fontSize24 {\n  font-size: 24px !important;\n}\n.link-cursor {\n  cursor: pointer;\n}\n.center-align-text{\n  text-align: center;\n}\n","@import url('https://fonts.googleapis.com/css2?family=Rubik:wght@300;400;500&display=swap');\n// (base)\n@import './base/colors';\n@import './base/spaces';\n@import './base/typography';\n// (layout)\n@import './layout/header';\n@import './layout/main';\n\n// (partials)\n@import './partials/menu';\n@import './partials/common';\n@import './partials/cards';\n@import './partials/reqCard';\n@import './partials/tabs';\n@import './partials/table';\n@import './partials/forms';\n@import './partials/steps';\n@import './partials/collapse';\n@import './partials/dashboard';\n\n// (pages)\n@import './pages/marketing';\n@import './pages//landing';\n@import './pages/login';",".c-header {\n    background:transparent;\n    position: fixed;\n    width: 100%;\n    z-index: 1;\n    .ant-card-body {\n        padding: 15px 30px 10px 30px;\n    }\n}\n\n.custom-select {\n    .ant-select-selection-placeholder {\n        color: #fff;\n    }\n    .ant-select-selection-item {\n        color: #fff;\n    }\n    &.ant-select-open {\n        .ant-select-selection-item {\n            color: #fff;\n        }\n    }\n}\n\n.ant-select-arrow {\n    color: #fff;\n}\n\n.search-input {\n    background: $container-color;\n    padding: 0px !important;\n    border: none;\n    .ant-select-selection-placeholder {\n        color: $gray;\n    }\n    .ant-input {\n        background: $container-color;\n    }\n    .ant-input-prefix {\n        margin-right: 10px;\n    }\n\n}\n","$blue: #0077b6;\n$base-color: #6F5BF6;\n$secondary-color:#EEECFF;\n$container-color: #f2f4f7;\n$element-color: #f2f4f7;\n$gray: #7D858F;\n$based-color: #bebebe;\n$green-color: #02a574;\n$green-dark: #03865e;\n$green-active: #016b4b;\n$gold-color: #e89005;\n$menu-gray: #2c2c2c;\n$errors: #c3423f;\n$errors-dark: #ab3836;\n$errors-light: #ce6664;\n$black-shade: #0e0e0e;\n$white: #fff;\n$main-color:#735AFF;\n$input-text-color:#252422;\n$prefix-color:rgba(64, 61, 57, 0.07);\n$border-color:#403D3925;",".site-page-header {\n  padding: 0;\n  .ant-page-header-heading-left {\n    margin: 0;\n  }\n}\n\n::-webkit-scrollbar {\n  width: 5px;\n  display: none;\n}\n\n::-webkit-scrollbar-thumb {\n  border-radius: 10px;\n  box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);\n  background: rgba(0, 0, 0, 0.2);\n}\n\n::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 5px $container-color;\n  border-radius: 0;\n  background: rgba(0, 0, 0, 0);\n}\n.base-layout {\n  @media (min-width: 1100px) {\n    padding: 81px 20px 0px 20px;\n  }\n\n  @media (min-width: 1650px) {\n    padding: 70px 30px 0px 30px;\n  }\n\n  @media only screen and (min-width: 360px) and (max-width: 1100px) {\n    padding: 130px 10px 10px 10px;\n  }\n}\n\n.ant-layout-sider {\n  background: transparent;\n}\n\n.flexibleRow {\n  display: grid;\n  grid-gap: 20px;\n  grid-template-columns: repeat(auto-fill, minmax(378px, 1fr));\n}\n\n.twocol-3070 {\n  display: flex;\n  @media (max-width: 1500px) {\n    flex-wrap: wrap;\n  }\n}\n\n.side-detail {\n  width: 380px;\n  max-width: 380px;\n  min-width: 300px;\n  padding-right: 20px;\n  @media (min-width: 1920px) {\n    min-width: 380px;\n  }\n  @media (max-width: 1500px) {\n    width: 100%;\n    min-width: unset;\n    max-width: 100%;\n    padding-right: 0;\n    padding-bottom: 20px;\n  }\n}\n\n.side-form {\n  width: 780px;\n  max-width: 100%;\n  @media (min-width: 1921px) {\n    width: 100%;\n  }\n  @media (max-width: 1500px) {\n    width: 100%;\n  }\n}\n\n.css-11r8ynb-MultiValueGeneric{\n  color: #000!important;\n}\n\n.css-18hvbcy-multiValue{\n  padding: 0 3px 0 14px!important;\n}\n\n.css-1tj4mlw-indicatorSeparator {\n  background-color: #fff!important;\n}",".main-menu {\n  background: transparent !important;\n  border: none;\n  .menu-item {\n    .ant-menu-title-content {\n      margin-left: 15px;\n    }\n  }\n  .ant-menu-item-selected {\n    background: $secondary-color !important;\n    .ant-menu-title-content {\n      font-weight: 600;\n      color: #252422;\n    }\n    .anticon path {\n      fill: $main-color;\n      stroke: $main-color;\n      opacity: 100%;\n    }\n    &:after {\n      transform: scaleY(0);\n      opacity: 1;\n    }\n  }\n}\n\n.menu-item {\n  color: transparent;\n  margin: 0 0 10px !important;\n  border-radius: 10px;\n  padding: 10px 15px !important;\n  height: auto !important;\n  .ant-menu-title-content {\n    font-weight: 600;\n    color: $gray;\n  }\n  &:hover {\n    background: $secondary-color;\n    .anticon path {\n      // stroke: $main-color;\n    }\n  }\n}\n.stats-icon {\n  stroke: $black-shade;\n}\n.ant-menu-title-content {\n  font-weight: 300;\n}\n.ant-menu .ant-menu-item-disabled,\n.ant-menu .ant-menu-submenu-disabled,\n.ant-menu .ant-menu-item-disabled > a,\n.ant-menu .ant-menu-submenu-disabled > a,\n.ant-menu .ant-menu-item-disabled > span > a,\n.ant-menu .ant-menu-submenu-disabled > span > a {\n  color: $gray !important;\n  opacity: 1;\n  cursor: default;\n}\n\n.submenu-item {\n  background-color: transparent;\n  .ant-menu-submenu-title {\n    color: #646777;\n  }\n  .ant-menu-sub {\n    color: #646777;\n  }\n  .menu-item {\n    &:last-child {\n      margin-bottom: 0 !important;\n    }\n  }\n}\n\n.side-card {\n  padding-top: 125px;\n  height: calc(100vh - 40px);\n  overflow: hidden;\n  transition: 0.2s;\n  background: transparent;\n  border-radius: 0px;\n  .ant-card-body {\n    padding: 0px;\n    background: transparent;\n  }\n}\n\n.navBar {\n  > .ant-card-body {\n    padding: 0;\n    background: transparent;\n  }\n}\n\n.navBarResponse {\n  .menu-item {\n    border-radius: 6px;\n    padding: 10px 15px !important;\n    height: 40px !important;\n    width: 50px !important;\n    margin-left: 25px !important;\n    .anticon {\n      font-size: 20px !important;\n      line-height: 1 !important;\n    }\n  }\n  .ant-divider-horizontal {\n    margin: 20px 0;\n    min-width: unset;\n    width: 50px;\n  }\n}\n\n.drawer-style {\n  .ant-drawer-header {\n    padding: 16px 24px;\n    z-index: 99999;\n    top: 0;\n    left: 0;\n    right: 0;\n    border-bottom: 1px solid #e8e8e8;\n  }\n  .ant-drawer-body {\n    padding: 0px;\n  }\n}\n\n.password-strength {\n  .ant-checkbox-disabled .ant-checkbox-inner {\n    border-color: $main-color !important;\n    background-color: transparent !important;\n  }\n  .ant-checkbox-disabled.ant-checkbox-checked .ant-checkbox-inner::after {\n    border-color: $main-color !important;\n   \n  }\n}\n","input:-webkit-autofill,\ninput:-webkit-autofill:hover,\ninput:-webkit-autofill:focus,\ntextarea:-webkit-autofill,\ntextarea:-webkit-autofill:hover,\ntextarea:-webkit-autofill:focus,\nselect:-webkit-autofill,\nselect:-webkit-autofill:hover,\nselect:-webkit-autofill:focus {\n  // transition: background-color 5000s ease-in-out 0s;\n  border: 0;\n  box-shadow: 0 0 0px 100px $element-color inset;\n  -webkit-box-shadow: 0 0 0px 100px $element-color inset;\n  -webkit-text-fill-color: $gray !important;\n}\n\n.d-none {\n  display: none !important;\n}\n\n.d-block {\n  display: block !important;\n}\n\n.d-inline-block {\n  display: inline-block !important;\n}\n\n.w-100 {\n  width: 100% !important;\n}\n\n.max-100 {\n  max-width: 100px;\n}\n\n.h-100 {\n  height: 100%;\n}\n\n.h-auto {\n  height: auto !important;\n}\n\n.ultra-550 {\n  height: 400px !important;\n}\n.text-center {\n  text-align: center !important;\n}\n\n.text-right {\n  text-align: right !important;\n}\n.text-left {\n  text-align: left !important;\n}\n.justify-right {\n  justify-content: flex-end;\n}\n.justify-cetner {\n  justify-content: center;\n}\n\n.position-relative {\n  position: relative;\n}\n\n.border-left {\n  border-left: 1px solid $menu-gray;\n}\n\n.right-fixed {\n  position: absolute;\n  top: 0;\n  right: 10px;\n}\n\n.p-0 {\n  padding: 0 !important;\n}\n.px-1 {\n  padding-left: 15px !important;\n  padding-right: 15px !important;\n}\n\n.px-2 {\n  padding-left: 80px !important;\n  padding-right: 80px !important;\n}\n\n.py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n\n.m-0 {\n  margin: 0 !important;\n}\n\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n.py-1 {\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n\n.py-5 {\n  padding-top: 50px;\n  padding-bottom: 50px;\n}\n\n.mb-10PX {\n  margin-bottom: 10px !important;\n}\n\n.ml-5 {\n  margin-left: 5px !important;\n}\n\n.mt-0 {\n  margin-top: 0 !important;\n}\n\n.mt-70 {\n  margin-top: 70px !important;\n}\n\n.mb-1 {\n  margin-bottom: 15px !important;\n}\n\n.mb-1-5 {\n  margin-bottom: 20px !important;\n}\n\n.mb-2 {\n  margin-bottom: 30px !important;\n}\n\n.mt-1 {\n  margin-top: 15px !important;\n}\n\n.mt-1-5 {\n  margin-top: 20px !important;\n}\n\n.mt-2 {\n  margin-top: 30px !important;\n}\n\n.mt-4 {\n  margin-top: 40px !important;\n}\n\n.mt-5 {\n  margin-top: 50px !important;\n}\n\n.ml-auto {\n  margin-left: auto;\n}\n\n.pl-0 {\n  padding-left: 10px !important;\n}\n.pl-1 {\n  padding-left: 20px !important;\n}\n\n.pl-2 {\n  padding-left: 30px !important;\n}\n\n.c-default {\n  color: $based-color !important;\n}\n\n.c-gray {\n  color: $gray !important;\n}\n.c-black {\n  color: #252422 !important;\n}\n\n.c-white {\n  color: #fff !important;\n}\n\n.c-link {\n  color: $blue;\n}\n\n.linkbtn {\n  height: auto;\n  line-height: 20px;\n}\n\n.c-gray-linkbtn {\n  color: $gray;\n  height: auto;\n  line-height: 20px;\n  &:hover,\n  &:focus {\n    color: #fff;\n  }\n}\n\n.downloadLink {\n  display: flex;\n  align-items: center;\n  color: $green-color;\n  line-height: 20px;\n  &:hover,\n  &:focus {\n    color: #fff;\n  }\n}\n\n.cross-iconbtn {\n  width: 20px !important;\n  height: 20px !important;\n  padding: 0 !important;\n  border-radius: 0;\n  font-size: 20px !important;\n  line-height: 1;\n  vertical-align: middle;\n  border: 0;\n  color: $based-color !important;\n  > * {\n    font-size: 20px;\n  }\n  &:hover,\n  &:focus {\n    color: $errors !important;\n  }\n}\n.graycross-icon {\n  color: $gray !important;\n  &:hover,\n  &:focus {\n    color: $errors !important;\n  }\n}\n\n.dashed-borderedbtn {\n  border-style: dashed;\n}\n\n.c-graybtn {\n  background-color: $menu-gray;\n  border: 0;\n}\n\n.c-success {\n  color: $green-color !important;\n}\n\n.b-success {\n  color: #fff;\n  background-color: $green-color;\n}\n\n.c-pending {\n  color: $gold-color !important;\n}\n\n.b-pending {\n  background-color: $gold-color;\n  color: #fff;\n}\n\n.b-black {\n  background-color: $black-shade !important;\n}\n\n.b-dark-gray {\n  background-color: $element-color;\n}\n\n.b-gray {\n  background: $container-color;\n}\n\n.c-error {\n  color: $errors !important;\n}\n\n.b-error {\n  color: #fff !important;\n  background-color: $errors !important;\n  .op-6 {\n    color: #fff;\n  }\n}\n\n.b-default {\n  color: #fff;\n  background-color: $menu-gray;\n}\n\n.b-primary {\n  color: #fff;\n  background-color: $blue;\n}\n\n.c-primary {\n  color: $blue;\n}\n\n.sole-icon {\n  width: 40px;\n  height: 40px;\n  border-radius: 50%;\n  padding: 10px;\n  display: inline-block;\n  .anticon {\n    vertical-align: 0;\n    color: $black-shade;\n    line-height: 20px;\n  }\n}\n\n.mt-PX {\n  margin-top: 10px !important;\n}\n\n.sole-anticon {\n  font-size: 40px !important;\n}\n\n.sole-icon-small {\n  width: 20px;\n  height: 20px;\n  border-radius: 50%;\n  padding: 5px;\n  display: inline-block;\n  font-size: 10px;\n  .anticon {\n    font-size: 1em !important;\n    color: $black-shade;\n    line-height: 10px;\n  }\n}\n\n.white-link {\n  color: #fff;\n  font-weight: 300;\n  padding: 0;\n  line-height: 2;\n  span {\n    text-decoration: underline;\n  }\n  &:hover {\n    color: $based-color;\n  }\n}\n\n.inAvatar {\n  position: absolute;\n  bottom: 0;\n  right: 0;\n  border: 10px solid $black-shade;\n}\n\n.thick-border-bottom {\n  border-bottom: 3px solid $menu-gray !important;\n}\n\n.highlight-border {\n  border-color: $based-color !important;\n}\n\n.small-btn {\n  height: auto;\n  border-radius: 15px;\n}\n\n.save-btn {\n  margin-top: 2em;\n}\n\n.op-1 {\n  opacity: 0.1;\n}\n\n.op-2 {\n  opacity: 0.2;\n}\n\n.op-3 {\n  opacity: 0.3;\n}\n\n.op-4 {\n  opacity: 0.4;\n}\n\n.op-5 {\n  opacity: 0.5;\n}\n\n.op-6 {\n  opacity: 0.6;\n}\n\n.op-7 {\n  opacity: 0.7;\n}\n\n.op-8 {\n  opacity: 0.8;\n}\n\n.op-9 {\n  opacity: 0.9;\n}\n\n.list-links {\n  padding: 0;\n  margin: 0;\n  white-space: pre-wrap;\n  line-height: 1.3;\n  text-align: left;\n  height: auto;\n  color: $based-color;\n  &:hover {\n    color: #fff;\n  }\n}\n\n.btnoutline-white {\n  background: transparent;\n  border-color: #fff;\n  color: #fff;\n  &:hover,\n  &:focus {\n    background: #fff;\n    border-color: #fff;\n    color: $black-shade;\n  }\n  &:active {\n    background: #fff;\n    border-color: #fff;\n  }\n}\n\n.green-btn {\n  background: $green-color;\n  border-color: $green-color;\n  &:hover,\n  &:focus {\n    background: $green-dark;\n    border-color: $green-dark;\n  }\n  &:active {\n    background: $green-active;\n    border-color: $green-active;\n  }\n}\n\n.black-btn {\n  background: #000;\n  border-color: #000;\n  &:hover,\n  &:focus {\n    background: #222;\n    border-color: #222;\n  }\n  &:active {\n    background: #121212;\n    border-color: #121212;\n  }\n}\n\n.red-btn {\n  background: $errors;\n  border-color: $errors;\n  &:hover,\n  &:focus {\n    background: $errors-dark;\n    border-color: $errors-dark;\n  }\n  &:active {\n    background: $errors-dark;\n    border-color: $errors-dark;\n  }\n}\n\n.gray-btn {\n  background: $based-color;\n  border-color: $based-color;\n  &:hover,\n  &:focus {\n    color: #fff;\n    background: $based-color;\n    border-color: $based-color;\n  }\n  &:active {\n    color: #fff;\n    background: $based-color;\n    border-color: $based-color;\n  }\n}\n\n.activeIcon {\n  font-size: 30px;\n}\n\n.customSelect {\n  line-height: 20px;\n  &:hover {\n    > div {\n      .css-1hb7zxy-IndicatorsContainer {\n        > div {\n          color: $base-color;\n        }\n      }\n      .css-1pahdxg-control {\n        display: none;\n      }\n    }\n  }\n  > div {\n    border-radius: 8px;\n    box-shadow: none;\n    .css-1uccc91-singleValue {\n      margin: 0;\n    }\n    .css-1hb7zxy-IndicatorsContainer {\n      > div {\n        margin: 5px 15px 5px 5px;\n        background-color: $secondary-color;\n        border-radius: 4px;\n      }\n    }\n    div {\n      span {\n        display: none;\n      }\n    }\n  }\n}\n\n.icon-list {\n  height: 340px;\n  overflow-x: hidden;\n  .ant-list-item {\n    padding: 15px 0;\n    .titlename {\n      transition: 0.3s;\n    }\n    &:hover {\n      .titlename {\n        color: #fff !important;\n      }\n    }\n  }\n}\n\n.withoutFigure {\n  height: 461px;\n}\n\n.ant-form-item-has-error {\n  .customSelect  {\n      border: 1px solid $errors; \n      border-radius: 8px;\n  }\n}\n\n.download-inputbtn {\n  position: absolute;\n  right: 30px;\n  padding: 0;\n  top: 6px;\n  z-index: 1;\n}\n\n.inline-form {\n  flex-wrap: nowrap;\n  .ant-form-item {\n    flex: auto;\n  }\n}\n\n.member-icon {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-evenly;\n  width: 100%;\n  .ant-avatar {\n    border: 0;\n    margin: 10px 0;\n    &:not(:first-child) {\n      margin: 10px 0;\n    }\n  }\n}\n\n// ant design customization\n.ant-layout-footer {\n  padding-left: 0;\n  padding-right: 0;\n}\n\n.ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {\n  // border-color: transparent;\n}\n\n.ant-input-affix-wrapper:focus,\n.ant-input-affix-wrapper-focused {\n  // border-color: $ora !important;\n  box-shadow: none;\n}\n\n.ant-input-prefix {\n  margin-right: 10px;\n}\n\n.ant-form-item-explain,\n.ant-form-item-extra {\n  font-size: 13px;\n}\n\n.ant-form-item-label\n  > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::before {\n  content: none;\n}\n\n.ant-form-item-label\n  > label.ant-form-item-required:not(.ant-form-item-required-mark-optional)::after {\n  display: inline-block;\n  margin-left: 4px;\n  color: $errors;\n  font-size: 12px;\n  font-family: SimSun, sans-serif;\n  line-height: 1;\n  content: \"*\";\n}\n\n.ant-input-search .ant-input:focus {\n  border-color: $blue;\n}\n\n.ant-switch-handle {\n  width: 18px;\n  height: 18px;\n}\n\n.ant-switch-checked .ant-switch-handle {\n  left: calc(100% - 18px - 3px);\n}\n\n.ant-input {\n  padding: 11.5px 15px;\n}\n.ant-input-number {\n  padding: 3.5px 15px;\n}\n.width100percent .ant-input-number {\n  width: 100%;\n}\n.padding-left-right {\n  padding-left: 15px;\n  padding-right: 15px;\n}\n.ant-input-affix-wrapper-lg {\n  padding: 11.5px 15px;\n}\n\n.inputGroupWithClose {\n  .ant-input-group-addon {\n    padding: 0;\n    border: 0;\n    min-width: 90px;\n  }\n  .ant-input {\n    width: calc(100% - 20px);\n    margin-left: 20px;\n    border-radius: 8px !important;\n  }\n}\n\n.doubleVal {\n  display: flex;\n  justify-content: space-between;\n}\n\n.uploadWithbtn {\n  .ant-upload {\n    width: 100%;\n  }\n}\n.avatar-uploader > .ant-upload {\n  width: 100%;\n  height: 225px;\n}\n.uploadTemplate > .ant-upload {\n  width: 100%;\n  height: 110px;\n}\n.ant-btn-dashed {\n  color: $blue;\n  border-color: $blue;\n}\n\n.ant-anchor-wrapper {\n  margin-left: 0;\n  padding-left: 0;\n}\n\n.ant-anchor {\n  line-height: 20px;\n  padding-left: 0;\n}\n\n.ant-anchor-link {\n  padding: 0;\n  line-height: 1;\n}\n\n.ant-select:not(.ant-select-customize-input) .ant-select-selector {\n  background-color: $white !important;\n  border: 1px solid $border-color;\n  box-shadow: none !important;\n  padding: 1px 14px;\n}\n\n.ant-select-single.ant-select-lg:not(.ant-select-customize-input)\n  .ant-select-selector {\n  padding: 0 15px;\n}\n\n.ant-select-arrow {\n  right: 15px;\n}\n\n.clickRow {\n  .ant-table-row {\n    cursor: pointer;\n  }\n}\n\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.ant-progress-show-info .ant-progress-outer {\n  margin-right: calc(-3em - 8px);\n  padding-right: calc(3em + 8px);\n}\n\n.ant-pagination-item{\n  border: 0px;\n}\n.ant-pagination-item-active {\n  background-color: #fff;\n  border: 1px solid $base-color;\n}\n\n.ant-radio-wrapper {\n    border: 1px solid #403D3925;\n    padding: 10px 63px 12px 12px;\n    border-radius: 6px;\n}\n.ant-message {\n  color: #fff;\n  top: 0;\n  .ant-message-notice {\n    padding: 0;\n    .ant-message-notice-content {\n      background-color: transparent;\n      padding: 0;\n      box-shadow: none;\n      display: block;\n\n      .ant-message-custom-content {\n        display: block;\n        padding: 10px;\n\n        &.ant-message-error {\n          background: rgba(238, 17, 17, 80%);\n\n          .anticon {\n            color: #fff;\n          }\n        }\n\n        &.ant-message-success {\n          background: rgba(2, 165, 116, 80%);\n\n          .anticon {\n            color: #fff;\n          }\n        }\n      }\n    }\n  }\n}\n\n// Export limit warning message - non-blocking style\n// Targets message container that contains export-limit-warning span\n.ant-message:has(.export-limit-warning) {\n  z-index: 0 !important; // Lower than header to allow header clicks\n  pointer-events: none; // Allow clicks to pass through message container\n  \n  .ant-message-notice {\n    pointer-events: auto; // But allow clicks on the message itself\n  }\n}\n\n.disableBody {\n  .ant-form-item-label {\n    label {\n      &:after {\n        display: none !important;\n      }\n    }\n  }\n\n  .fullWidth-checbox {\n    display: none !important;\n  }\n}\n.ant-drawer-header-title {\n  display: none;\n}\n// .ant-tag {\n//   margin-right: 0px;\n//   color: $gray;\n//   font-weight: 600;\n//   font-size: 12px;\n// }\n\n.ant-breadcrumb-link {\n  background-color: #f5f5f5;\n  border-radius: 9.5px;\n  padding: 2px 9px;\n  font-size: 12px;\n}\n.ant-divider-dashed {\n  border-width: 3px 0 0;\n}\n.group-avatar {\n  .ant-avatar-circle {\n    margin-right: 10px;\n  }\n}\n.billing-slider {\n  body {\n    .ant-tooltip-inner {\n      padding: 5px 7px 0px 7px;\n      background: #55cde5;\n      color: white;\n      border-radius: 100px;\n    }\n  }\n}\n\n.btn-link {\n  .ant-btn-link {\n    color: $base-color !important;\n  }\n}\n.auto-select-remove {\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: \"none\";\n  user-select: none;\n}\n\n.ant-input-search-large .ant-input-search-button{\n  height: 49px;\n}\n\n.item-width-100 {\n  .ant-descriptions-item-label{\n    width: 100%;\n  }\n}\n\n.status-dot{\n  .ant-badge-status-dot{\n    height: 10px;\n    width: 10px;\n  }\n}\n\n.dashboard-subtitle{\n  font-weight: 400;\n  font-size: 24px;\n}\n\n.video-frame{\n  border-radius: 8px;\n}\n\n.ant-steps-label-vertical .ant-steps-item-content {\n  display: block;\n  width: 110px;\n  margin-top: -160px;\n  text-align: center;\n  /* Additional styles can be added here */\n}\n\n.step-style {\n  margin-top: 18vh;\n  padding-bottom: 10vh;\n}\n\n.step-avatar-text {\n  color: #7D858F;\n  font-size: 14px;\n  font-weight: 600;\n}\n\n.ant-divider-vertical {\n  position: relative;\n  top: -0.06em;\n  display: inline-block;\n  height: 0.9em;\n  margin: 0 8px;\n  vertical-align: middle;\n  border-top: 0;\n  border-left: 2px solid #D9DCE0;\n}\n\n.empty-notification {\n  padding-left: 20px;\n  padding-right: 20px;\n}\n\n.align-center {\n  .ant-card-body {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n.dummy-image-container {\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  margin-top: 30px;\n  margin-bottom: 30px;\n}\n.dummy-image-container-guest {\n  justify-content: center;\n  align-items: center;\n  display: flex;\n  margin-bottom: 30px;\n}\n\n.dummy-image-border {\n    border-radius: 7px;\n    box-shadow: 0px 10px 25px 0px #00000012;\n    border: 1px solid #C7BEFF;\n    \n}\n\n.payment-text-color {\n  color: #5c5c5c !important;\n}\n\n.heading-desc{\n  margin-top: 15px;\n  margin-bottom: 20px;\n}\n.export-limit-warning {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  padding: 12px 20px;\n  border-radius: 8px;\n  background: rgba(250, 137, 0, 0.15);\n  color: #8a4c00;\n  font-weight: 600;\n  font-size: 14px;\n  border: 1px solid rgba(250, 137, 0, 0.35);\n  box-shadow: 0 8px 18px rgba(250, 137, 0, 0.15);\n  margin: 0 auto;\n  max-width: 110vw;\n  text-align: center;\n}",".login-card {\n  // box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);\n  // border-radius: 10px;\n  background: transparent;\n  .ant-card-body {\n    padding: $largespace-xl $mediumspace-xl;\n    @media (max-width: 1366px) {\n      padding: $largespace-lg $mediumspace-lg;\n    }\n    @media (max-width: 767px) {\n      padding: $largespace-xs $mediumspace-xs;\n    }\n  }\n}\n\n.ant-card-body {\n  &:before,\n  &:after {\n    content: none;\n  }\n}\n\n.design-card {\n  height: 100%;\n  border-radius: 20px;\n  transition: 0.2s;\n  box-shadow: 0px 5px 20px rgba(225, 125, 56, 0.1), inset 0px 4px 4px #ffffff;\n  .ant-card-body {\n    position: relative;\n    padding: $mediumspace-xl;\n    @media (max-width: 1366px) {\n      padding: $mediumspace-lg;\n    }\n    @media (max-width: 767px) {\n      padding: $mediumspace-xs;\n    }\n  }\n}\n\n.design-card-payment {\n  height: 100%;\n  border-radius: 20px;\n  transition: 0.2s;\n  width: 100%;\n  // box-shadow: 0px 5px 20px rgba(225, 125, 56, 0.1), inset 0px 4px 4px #ffffff;\n  .ant-card-body {\n    position: relative;\n    padding: $mediumspace-xl;\n    @media (max-width: 1366px) {\n      padding: $mediumspace-lg;\n    }\n    @media (max-width: 767px) {\n      padding: $mediumspace-xs;\n    }\n  }\n}\n\n.design-card-guest-dashboard {\n  height: 100%;\n  border-radius: 20px;\n  transition: 0.2s;\n  box-shadow: 0px 5px 20px rgba(225, 125, 56, 0.1), inset 0px 4px 4px #ffffff;\n  .ant-card-body {\n    position: relative;\n    padding-left: 15vh;\n    padding-top: 10vh;\n    padding-right: 10vh;\n    // padding: $mediumspace-xl;\n    @media (max-width: 1366px) {\n      padding: $mediumspace-lg;\n    }\n    @media (max-width: 767px) {\n      padding: $mediumspace-xs;\n    }\n  }\n}\n\n\n.side-panel {\n  height: calc(100vh - 296px);\n  .ant-card-body {\n    height: 100%;\n  }\n}\n\n\n.transparent-card {\n  width: 100%;\n  overflow-x: hidden;\n  background: transparent;\n  > .ant-card-body {\n    padding: 0px 0px 0px 30px;\n  }\n}\n\n.small-card {\n  width: 100%;\n  overflow-x: hidden;\n  background: transparent;\n  > .ant-card-body {\n    padding: 0px 0px 0px 0px;\n  }\n}\n\n.os-card {\n  width: 341px;\n  height: 315px;\n  padding: 40px;\n  display: \"flex\";\n  flex-direction: \"column\";\n  justify-content: \"center\";\n}\n.no-card-aform {\n  width: 100%;\n  background-color: transparent;\n  margin-bottom: 10px;\n  > .ant-card-body {\n    padding: 0;\n  }\n}\n\n.statistic-card {\n  width: 100%;\n  height: 100%;\n  border-radius: 0;\n  border-left: 1px solid $menu-gray;\n  background-color: transparent;\n  overflow-x: hidden;\n  > .ant-card-body {\n    padding: 0 30px;\n  }\n}\n\n\n\n.stats-card {\n  background: #ffffff;\n  border:  1px solid #C7BEFF;\n  border-radius: 12px;\n}\n\n.design-card-small {\n  height: 100%;\n  border-radius: 8px;\n  > .ant-card-body {\n    padding: 20px;\n  }\n  .anticon {\n    font-size: 20px;\n  }\n}\n\n.design-card-xsmall {\n  height: 100%;\n  border-radius: 8px;\n  > .ant-card-body {\n    padding-left: 20px;\n    padding-right: 20px;\n    padding-top: 20px;\n    padding-bottom: 0px;\n  }\n  .anticon {\n    font-size: 20px;\n  }\n}\n\n.figures-card {\n  transition: 0.2s;\n  .ant-card-body {\n    padding: $smallspace-xl;\n  }\n}\n\n.landscape-card {\n  height: 100%;\n  .ant-card-body {\n    height: '100% !important';\n    display: flex;\n    flex-flow: column;\n    justify-content: space-between;\n  }\n}\n\n\n\n.nospace-card {\n  background: transparent !important;\n  width: 100%;\n  box-shadow: none !important;\n  .ant-card-body {\n    padding: 0;\n  }\n}\n\n.logs-table{\n  background: transparent !important;\n  width: 100%;\n  height: 94% !important;\n  box-shadow: none !important;\n  .ant-card-body {\n    padding: 0;\n  }\n}\n\n.custom-card-graph .ant-card-body {\n  border: none !important;\n}\n.custom-card-graph .ant-card-head {\n  border: none !important;\n}\n.ant-card .ant-card-bordered .custom-card-graph{\n  border: none !important;\n}\n.copyable-card{\n  .ant-card-body {\n    max-width: 95%;\n  }\n}\n\n.black-modal {\n  .ant-modal-body {\n    // padding: 50px 90px;\n  }\n  .ant-modal {\n    // text-align: center;\n  }\n  .ant-modal-content {\n    border-radius: 12px;\n  }\n  .ant-modal-confirm-body {\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    .anticon {\n      float: none;\n      margin: 0 0 20px;\n      font-size: 50px;\n    }\n    .ant-modal-confirm-title {\n      font-size: 26px;\n      font-weight: 400;\n      margin: 0 0 20px;\n    }\n    .ant-modal-confirm-content {\n      margin: 0;\n      line-height: 20px;\n    }\n  }\n  .ant-modal-confirm-btns {\n    float: none;\n    margin-top: 50px;\n  }\n}\n","// desktop\n\n$largespace-xl: 50px;\n$mediumspace-xl: 30px;\n$smallspace-xl: 20px;\n$base-size-xl: 15px;\n\n// 1366\n$largespace-lg: 32px;\n$mediumspace-lg: 20px;\n$smallspace-lg: 14px;\n\n// mobile\n$largespace-xs: 24px;\n$mediumspace-xs: 12px;\n$smallspace-xs: 8px;\n\n",".reqData {\n  .ant-descriptions-item {\n     border-bottom: 0.7px solid rgba(224, 214, 227, 1);\n  }\n  .ant-descriptions-row{\n    // border: 0;\n  }\n  .ant-descriptions-item-label {\n    background: transparent;\n    // border: 0;\n  }\n  .ant-descriptions-item-content {\n\n    // border: 0;\n  }\n}\n",".custom-tabs {\n  overflow: unset;\n  > .ant-tabs-nav {\n    .ant-tabs-nav-wrap {\n      .ant-tabs-nav-list {\n        @media only screen and (min-width: 360px) and (max-width: 767px) {\n          width: none;\n        }\n        @media (min-width: 768px) {\n          width: 35%;\n        }\n        padding: 5px;\n        border-radius: 8px;\n        .ant-tabs-tab {\n          width: 100%;\n          height: 40px;\n          border-radius: 8px !important;\n          justify-content: center;\n        }\n        .ant-tabs-ink-bar {\n          height: 4px;\n          border-radius: 20px\n        }\n      }\n    }\n  }\n\n  > .ant-tabs-nav .ant-tabs-tab,\n  > div > .ant-tabs-nav .ant-tabs-tab {\n    border: 0;\n  }\n  > .ant-tabs-nav .ant-tabs-tab-active,\n  > div > .ant-tabs-nav .ant-tabs-tab-active {\n    // color: #fff;\n    // background-color: $blue;\n  }\n}\n\n.-space30 {\n  .ant-tabs-nav {\n    margin-bottom: $mediumspace-xl;\n  }\n}\n\n.tab-badge {\n  .ant-badge-count {\n    padding: 0 15px;\n    height: 30px;\n    font-size: 15px;\n    line-height: 30px;\n    background-color: $menu-gray;\n    color: #fff;\n  }\n}\n\n.menu-badge {\n  .ant-badge-count {\n    width: 20px;\n    height: 20px;\n    font-size: 15px;\n    line-height: 20px;\n    border-radius: 4px;\n    background-color: $black-shade;\n    color: #fff;\n    padding: 0;\n  }\n}\n\n.tab-bold {\n  position: relative;\n  > .ant-tabs-nav {\n    .ant-tabs-tab {\n      border: 0;\n      font-size: 18px;\n      font-weight: 400;\n      .ant-tabs-tab-btn {\n        color: $gray;\n      }\n      .tab-header {\n        color: $gray;\n        transition: 0.2s;\n        font-size: 18px;\n        font-weight: 400;\n      }\n      &:first-child {\n        padding-left: 0;\n      }\n    }\n    &:before {\n      content: none;\n    }\n    .ant-tabs-tab-active {\n      background-color: transparent;\n      font-size: 26px;\n      font-weight: 400;\n      .ant-tabs-tab-btn {\n        color: #fff;\n      }\n      .tab-header {\n        color: #fff;\n        font-size: 24px;\n        font-weight: 400;\n      }\n      .tab-badge {\n        .ant-badge-count {\n          background-color: $errors;\n        }\n      }\n    }\n  }\n  > div > .ant-tabs-nav {\n    .ant-tabs-tab {\n      border: 0;\n      font-size: 18px;\n      font-weight: 400;\n      .ant-tabs-tab-btn {\n        color: $gray;\n      }\n      .tab-header {\n        color: $gray;\n        font-size: 18px;\n        font-weight: 400;\n      }\n    }\n    &:before {\n      content: none;\n    }\n    .ant-tabs-tab-active {\n      font-size: 26px;\n      font-weight: 400;\n      background-color: transparent;\n      .ant-tabs-tab-btn {\n        color: #fff;\n      }\n      .tab-header {\n        color: #fff;\n        font-size: 26px;\n        font-weight: 400;\n      }\n    }\n  }\n}\n\n.optionsTabs {\n  //position: absolute;\n  top: 13px;\n  right: 0;\n  .ant-radio-button-wrapper {\n    border: 0;\n    font-size: 16px;\n    line-height: 2;\n    background: $container-color;\n  }\n  .ant-radio-button-wrapper:first-child {\n    border: 0;\n  }\n  .ant-radio-button-wrapper:not(:first-child)::before {\n    content: none;\n  }\n}\n.optionsTabsRes {\n  position: relative;\n  //margin-bottom: 20px;\n  top: 0;\n  justify-content: flex-end;\n  width: 100%;\n}\n.payment_tabs {\n  overflow: unset;\n  > .ant-tabs-nav {\n    &::before {\n      content: normal;\n    }\n    .ant-tabs-nav-wrap {\n      .ant-tabs-nav-list {\n        width: 55%;\n        padding: 5px 5px 10px 5px;\n        .ant-tabs-tab {\n          width: 100%;\n          border: 1px solid rgba(141, 149, 160, 0.25);;\n          height: 60px;\n          border-radius: 8px !important;\n          margin-right: 15px;\n          font-weight: 700;\n          font-size: 13px;\n          background-color: white;\n          &:hover {\n            color: black\n          }\n          &.ant-tabs-tab-active {\n            color: black;\n            background-color: white;\n            box-shadow: 0px 5px 10px rgba(0, 0, 0, 0.15);;\n            .ant-tabs-tab-btn {\n              color: black;\n             \n            }\n          }\n        }\n      }\n    }\n  }\n  > .ant-tabs-nav .ant-tabs-tab,\n  > div > .ant-tabs-nav .ant-tabs-tab {\n    border: 0;\n  }\n  > .ant-tabs-nav .ant-tabs-tab-active,\n  > div > .ant-tabs-nav .ant-tabs-tab-active {\n    color: #fff;\n    background-color: $blue;\n  }\n}\n.billing-tabs {\n  overflow: unset;\n  > .ant-tabs-nav {\n    &::before {\n      content: normal;\n    }\n    .ant-tabs-nav-wrap {\n      .ant-tabs-nav-list {\n        width: 55%;\n        padding: 5px 5px 10px 5px;\n        .ant-tabs-tab {\n          width: 100%;\n          border: 1px solid rgba(141, 149, 160, 0.25);;\n          height: 60px;\n          border-radius: 8px !important;\n          margin-right: 15px;\n          background-color: white;\n          justify-content: center;\n          &.ant-tabs-tab-active {\n            box-shadow: 0px 4px 12px rgba(0, 180, 216, 0.2);\n            border-color: #6F5BF6;\n          }\n        }\n      }\n    }\n  }\n  > .ant-tabs-nav .ant-tabs-tab,\n  > div > .ant-tabs-nav .ant-tabs-tab {\n    border: 0;\n  }\n}\n.payment-slider{\n  .ant-slider-rail{\n    background-color: transparent;\n    border: 1px solid #55CDE5;\n    border-style: dashed;\n  }\n}",".custom-table {\n  .ant-table-thead > tr > th,\n  .ant-table-tbody > tr > td {\n    font-weight: 400;\n    line-height: 1;\n    padding: 18px 0px 18px 30px;\n  }\n  .ant-table-thead>tr>th{\n    color:$input-text-color ;\n    background-color: $secondary-color;\n  }\n  .ant-table-thead > tr:first-child th:first-child{\n    // border-top-left-radius:18px;\n  }\n  .ant-table-thead > tr:first-child th:last-child{\n    // border-top-right-radius:18px;\n  }\n  \n}\n.ant-table-thead th.ant-table-column-has-sorters:hover{\n  background-color: #EEECFF;\n}\n.radio-tabs {\n  display: flex;\n  width: 100%;\n  padding: 5px;\n  background-color: #0e0e0e;\n  border-radius: 12px;\n  .ant-radio-button-wrapper {\n    color: $gray;\n    width: 100%;\n    border-radius: 8px;\n    border: 0;\n    text-align: center;\n    &:not(:first-child)::before {\n      content: none;\n    }\n    &:hover {\n      color: #fff;\n    }\n  }\n}\n\n.transparent-table {\n  .ant-table {\n    background-color: transparent !important;\n    thead > tr > th {\n      background-color: transparent !important;\n      border-bottom: 1px solid $menu-gray !important;\n    }\n  }\n}\n",".fullWidth-checbox {\n  label {\n    width: 50%;\n    padding: 8.5px 15px;\n    background: transparent;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    flex-flow: row-reverse;\n    justify-content: space-between;\n    span {\n      color: #646777;\n      line-height: 20px;\n      padding-left: 0;\n    }\n  }\n  .ant-checkbox {\n    top: 0;\n  }\n  .ant-checkbox-inner {\n    border-radius: 4px;\n  }\n  .ant-checkbox-group-item {\n    &::after {\n      content: none;\n    }\n  }\n}\n\n.graycheckbox {\n  .ant-checkbox-wrapper:hover .ant-checkbox-inner,\n  .ant-checkbox:hover .ant-checkbox-inner,\n  .ant-checkbox .ant-checkbox-input:focus + .ant-checkbox-inner {\n    border-color: $based-color;\n  }\n  .ant-checkbox-checked .ant-checkbox-inner,\n  .ant-checkbox-checked:hover .ant-checkbox-inner,\n  .ant-checkbox-wrapper:hover .ant-checkbox-checked .ant-checkbox-inner,\n  .ant-checkbox-checked .ant-checkbox-input:focus + .ant-checkbox-inner {\n    border-color: $container-color;\n    background: $container-color;\n  }\n  .ant-checkbox-checked::after {\n    border-color: $container-color;\n  }\n  .ant-checkbox-checked .ant-checkbox-inner::after {\n    border-color: $gray;\n  }\n}\n\n.labeldefaultFont {\n  align-items: center;\n  .ant-form-item-label > label {\n    font-size: 15px;\n    line-height: 24px;\n  }\n}\n\n.gray-input {\n  .ant-input {\n    background-color: $menu-gray;\n  }\n}\n\n.select-withicon {\n  .searchIcon {\n    position: absolute;\n    top: 8px;\n    left: 20px;\n    font-size: 20px;\n    z-index: 1;\n  }\n  .ant-select-selector {\n    .ant-select-selection-search,\n    .ant-select-selection-placeholder,\n    .ant-select-selection-item {\n      padding-left: 30px;\n    }\n  }\n}\n.no-arrow {\n  input[type=number]::-webkit-inner-spin-button, \n  input[type=number]::-webkit-outer-spin-button { \n      -webkit-appearance: none; \n      margin: 0; \n  }\n}",".custom-steps {\n    &.ant-steps {\n        width: calc(100% + 40px);\n        margin: 0 -20px;\n        .ant-steps-item-custom {\n            .ant-steps-item-container {\n                display: flex;\n                flex-direction: column;\n                align-items: center;\n            }\n            .ant-steps-item-icon  {\n                width: 40px;\n                height: 40px;\n                margin: 0;\n                line-height: 20px;\n                border: 0;\n                border-radius: 50%;\n                overflow: hidden;\n                background: none;\n                .ant-steps-icon {\n                    background: $menu-gray;\n                    position: relative;\n                    font-size: 20px;\n                    width: 40px;\n                    height: 40px;\n                    line-height: 40px;\n                    left: 0;\n                    display: inline-block;\n                    z-index: 1;\n                    color: #fff;\n                }\n                &::after {\n                    content: '';\n                    position: absolute;\n                    top: 18.5px;\n                    left: auto;\n                    right:50%;\n                    display: block;\n                    width: 100%;\n                    height: 3px;\n                    border-top: 3px solid $menu-gray;\n                    \n                }\n                \n            }\n            .ant-steps-item-description {\n                text-align: center;\n                padding: 0 4px;\n                margin-top: 10px;\n                line-height: 20px;\n                color: $gray;\n            }\n            &:first-child {\n                .ant-steps-item-icon  {\n                    &::after {\n                        content: none;\n                    }\n                }\n            }\n            &:last-child {\n                flex: 1;\n            }\n        }\n        .ant-steps-item-finish {\n            .ant-steps-item-icon {\n                >.ant-steps-icon {\n                    background: $green-color;\n                    color: #fff;\n                }\n                &:after {\n                    border-color: $green-color;\n                }\n            }\n            .ant-steps-item-description {\n                color: $based-color;\n            }\n        }\n        .ant-steps-item-process {\n            .ant-steps-item-icon {\n                >.ant-steps-icon {\n                    background: $errors;\n                    color: #fff;\n                }\n                &:after {\n                    border: 2px dashed $errors\n                }\n            }\n            .ant-steps-item-description {\n                color: $based-color;\n            }\n        }\n        \n        .ant-steps-item {\n            padding: 0;\n            overflow: unset;\n        }\n        .ant-steps-item-title::after {\n            content: none;\n        }\n        \n    }\n}\n\n    \n.notitle-step {\n    &.ant-steps {\n        width: 100%;\n        margin: 0;\n        .ant-steps-item-custom {\n            &:first-child {\n                .ant-steps-item-container {\n                    align-items: flex-start;\n                }\n            }\n            &:last-child {\n                .ant-steps-item-container {\n                    align-items: flex-end;\n                }\n            }\n        }\n    }\n}",".custom-collapse .ant-collapse-item {\n  margin-bottom: 16px;\n}\n",".dashboard-grid-ui .ant-card-body {\n    padding: 40px 30px;\n}\n\n.ant-card-bordered {\n    border-radius: 12px;\n}\n\n.my-breadcrumb-item {\n    flex-direction: row;\n    justify-content: center;\n    align-items: center;\n    padding: 3px 11px;\n    gap: 10px;\n    width: 53px;\n    height: 21px;\n    /* Grey/Grey 100 */\n    background: #F5F5F5;\n    border-radius: 9.5px;\n    /* Inside auto layout */\n    flex: none;\n    order: 0;\n    flex-grow: 0;\n    font-size: 12px;\n}\n\n.ant-breadcrumb {\n    margin-bottom: 30px;\n}\n\n.col-design {\n    border: 1px solid rgba(141, 149, 160, 0.15);\n    border-radius: 12px;\n}\n\n.col-design .ant-table-content {\n    padding: 15px;\n}\n\n.col-design .ant-table-content tr th {\n    font-size: 16px;\n    font-weight: 600;\n    color: #000C0F;\n}\n\n.col-design2 {\n    border: 1px solid rgba(141, 149, 160, 0.15);\n    border-radius: 12px;\n}\n\n.col-design2 .ant-table-content {\n    padding: 15px;\n}\n\n.col-design2 .ant-table-content tr th {\n    font-size: 14px;\n    font-weight: 600;\n    color: #000C0F;\n}\n\n.col-design3 {\n    padding: 20px;\n    height: 710px;\n}\n\n.col-design4 {\n    padding: 20px;\n}",".circleProgress {\n  width: 100%;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: 6.5em;\n\n  .ant-progress-inner {\n    max-width: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n.percent-text {\n  font-size: 34px;\n  font-weight: 500;\n\n  span {\n    font-size: 15px;\n    font-weight: 400;\n  }\n}\n\n.percent-numb {\n  font-size: 15px;\n  font-weight: 400;\n  width: 100%;\n  margin-top: 10px;\n}\n\n.card-text {\n  padding: 20px;\n  background-color: $black-shade;\n  border-radius: 8px;\n  text-align: center;\n  width: 100%;\n}\n\n.divDisable {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  left: 0;\n  top: 0;\n  z-index: 1;\n}\n\n.disableBody {\n  .ant-tabs-tabpane {\n    position: relative;\n  }\n}\n\n.ant-form-item-control-input-content {\n  button.ant-btn.ant-btn-text {\n    position: absolute;\n    z-index: 9999;\n    right: 0;\n    top: 6px;\n    //background: #202020;\n    padding: 0 10px;\n  }\n}\n",".landing-layout {\n    width: 100%;\n    overflow: hidden;\n    .ant-row-middle {\n      min-height: 100vh;\n    }\n  }",".login-layout {\n    width: 100%;\n    overflow: hidden;\n    .ant-row-middle {\n      padding: 100px 24px 24px 24px;\n      min-height: 100vh;\n    }\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
